var _regeneratorRuntime = require("/workspace/node_modules/@babel/runtime/regenerator");

/*!
 * 
 * @twilio/flex-sdk.js 0.6.0
 * The following license applies to all parts of this software except as documented below.
 * 
 * Copyright (c) 2020 Twilio, Inc.
 * All rights reserved.
 * 
 * Licensed under the Apache License, Version 2.0 (the “License”);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * 
 *     http://www.apache.org/licenses/LICENSE-2.0
 * 
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an “AS IS” BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * 
 */
module.exports = function (e) {
  var t = {};

  function n(r) {
    if (t[r]) return t[r].exports;
    var o = t[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
  }

  return n.m = e, n.c = t, n.d = function (e, t, r) {
    n.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: r
    });
  }, n.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, n.t = function (e, t) {
    if (1 & t && (e = n(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var r = Object.create(null);
    if (n.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var o in e) {
      n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
    }
    return r;
  }, n.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return n.d(t, "a", t), t;
  }, n.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, n.p = "", n(n.s = 126);
}([function (e, t) {
  e.exports = require("inversify");
}, function (e, t, n) {
  "use strict";

  n.d(t, "g", function () {
    return r.a;
  }), n.d(t, "j", function () {
    return r.d;
  }), n.d(t, "h", function () {
    return r.b;
  }), n.d(t, "i", function () {
    return r.c;
  }), n.d(t, "c", function () {
    return o.a;
  }), n.d(t, "d", function () {
    return v;
  }), n.d(t, "a", function () {
    return b.a;
  }), n.d(t, "e", function () {
    return h.a;
  }), n.d(t, "f", function () {
    return y.a;
  }), n.d(t, "b", function () {
    return m.a;
  });
  var r = n(34),
      o = n(45);
  n(92);

  function i(e) {
    return (i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function a(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }

  function u(e, t) {
    return !t || "object" !== i(t) && "function" != typeof t ? c(e) : t;
  }

  function c(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }

  function s(e) {
    var t = "function" == typeof Map ? new Map() : void 0;
    return (s = function s(e) {
      if (null === e || (n = e, -1 === Function.toString.call(n).indexOf("[native code]"))) return e;
      var n;
      if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");

      if (void 0 !== t) {
        if (t.has(e)) return t.get(e);
        t.set(e, r);
      }

      function r() {
        return l(e, arguments, p(this).constructor);
      }

      return r.prototype = Object.create(e.prototype, {
        constructor: {
          value: r,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), d(r, e);
    })(e);
  }

  function l(e, t, n) {
    return (l = f() ? Reflect.construct : function (e, t, n) {
      var r = [null];
      r.push.apply(r, t);
      var o = new (Function.bind.apply(e, r))();
      return n && d(o, n.prototype), o;
    }).apply(null, arguments);
  }

  function f() {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }

  function d(e, t) {
    return (d = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  function p(e) {
    return (p = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  var v = function (e) {
    !function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && d(e, t);
    }(o, e);
    var t,
        n,
        r = (t = o, n = f(), function () {
      var e,
          r = p(t);

      if (n) {
        var o = p(this).constructor;
        e = Reflect.construct(r, arguments, o);
      } else e = r.apply(this, arguments);

      return u(this, e);
    });

    function o() {
      var e,
          t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "Internal Error";
      return a(this, o), e = r.call(this, t), Object.setPrototypeOf(c(e), o.prototype), e;
    }

    return o;
  }(s(Error)),
      b = n(26),
      h = n(28),
      y = n(38),
      m = n(61);
}, function (e, t, n) {
  "use strict";

  n.d(t, "b", function () {
    return r;
  }), n.d(t, "a", function () {
    return o;
  });
  n(42), n(94), n(60);

  function r(e) {
    var t = e.match("/modules/[A-z]+");
    return t ? t[0].replace("/modules/", "") : "";
  }

  function o(e) {
    var t = e.match("([A-z])+([.]*[A-z]*)[.][jt]s");
    return t ? t[0] : "";
  }
}, function (e, t) {
  e.exports = require("core-js/modules/es.object.to-string.js");
}, function (e, t, n) {
  "use strict";

  function r(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }

  var o;
  n.d(t, "a", function () {
    return i;
  }), n.d(t, "b", function () {
    return a.a;
  }), n.d(t, "c", function () {
    return a.c;
  }), n.d(t, "d", function () {
    return u.b;
  }), n.d(t, "e", function () {
    return u.d;
  }), function (e) {
    e.Trace = "trace", e.Debug = "debug", e.Info = "info", e.Warn = "warn", e.Error = "error";
  }(o || (o = {}));

  var i = function e(t) {
    var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : o.Debug;
    r(this, e), this.loggerName = t, this.severity = n, this.timestamp = new Date(), this.context = {};
  },
      a = n(44),
      u = n(20);
}, function (e, t) {
  e.exports = require("core-js/modules/es.array.iterator.js");
}, function (e, t) {
  e.exports = require("core-js/modules/es.string.iterator.js");
}, function (e, t) {
  e.exports = require("core-js/modules/web.dom-collections.iterator.js");
}, function (e, t) {
  e.exports = require("regenerator-runtime/runtime.js");
}, function (e, t, n) {
  "use strict";

  var r = n(30);
  n.d(t, "b", function () {
    return r.b;
  }), n.d(t, "a", function () {
    return r.a;
  }), n.d(t, "d", function () {
    return r.e;
  }), n.d(t, "e", function () {
    return r.g;
  }), n.d(t, "c", function () {
    return r.d;
  });
}, function (e, t, n) {
  "use strict";

  var r = n(27);
  n.d(t, "b", function () {
    return r.d;
  });
  var o = n(69);
  n.d(t, "a", function () {
    return o.a;
  });
}, function (e, t) {
  e.exports = require("core-js/modules/es.weak-map.js");
}, function (e, t, n) {
  "use strict";

  n.d(t, "d", function () {
    return r;
  }), n.d(t, "f", function () {
    return o;
  }), n.d(t, "b", function () {
    return i;
  }), n.d(t, "e", function () {
    return a;
  }), n.d(t, "c", function () {
    return u;
  }), n.d(t, "g", function () {
    return c;
  }), n.d(t, "a", function () {
    return s;
  });
  n(23), n(24), n(3);
  var r = Symbol.for("SyncAdapter"),
      o = Symbol.for("TwilsockAdapter"),
      i = Symbol.for("HttpAdapter"),
      a = "TelemetryService",
      u = "QueueStatsService",
      c = "WorkspaceStatsService",
      s = "ConfigurationService";
}, function (e, t) {
  e.exports = require("core-js/modules/es.promise.js");
}, function (e, t, n) {
  "use strict";

  var r;
  n.d(t, "a", function () {
    return r;
  }), n.d(t, "d", function () {
    return o.d;
  }), n.d(t, "c", function () {
    return o.c;
  }), n.d(t, "b", function () {
    return o.b;
  }), function (e) {
    e.TokenExpired = "tokenExpired", e.TokenAboutToExpire = "tokenAboutToExpire", e.TokenUpdated = "tokenUpdated", e.TokenAutoUpdateFailed = "tokenAutoUpdateFailed", e.TokenMaxLifetimeReached = "tokenMaxLifetimeReached", e.ConnectionLost = "connectionLost", e.ConnectionRestored = "connectionRestored", e.Disconnected = "disconnected";
  }(r || (r = {}));
  var o = n(43);
}, function (e, t, n) {
  "use strict";

  n.d(t, "b", function () {
    return r;
  }), n.d(t, "a", function () {
    return o.a;
  });
  n(49), n(22);

  function r(e, t, n, r) {
    e.on(n, function () {
      for (var e = arguments.length, n = new Array(e), o = 0; o < e; o++) {
        n[o] = arguments[o];
      }

      t.emit.apply(t, [r].concat(n));
    });
  }

  var o = n(58);
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return r;
  }), n.d(t, "h", function () {
    return o;
  }), n.d(t, "g", function () {
    return i;
  }), n.d(t, "d", function () {
    return a;
  }), n.d(t, "f", function () {
    return u;
  }), n.d(t, "e", function () {
    return c;
  }), n.d(t, "c", function () {
    return s;
  }), n.d(t, "b", function () {
    return l;
  });
  n(23), n(24), n(3);
  var r = Symbol.for("NewableSyncClient"),
      o = Symbol.for("Sync"),
      i = Symbol.for("SyncProvider"),
      a = Symbol.for("SyncCache"),
      u = Symbol.for("SyncMapProvider"),
      c = Symbol.for("SyncMapItemProvider"),
      s = Symbol.for("NewableSyncMap"),
      l = Symbol.for("NewableSyncMapItem");
}, function (e, t, n) {
  "use strict";

  n.d(t, "b", function () {
    return r;
  }), n.d(t, "a", function () {
    return o;
  }), n.d(t, "d", function () {
    return i;
  }), n.d(t, "c", function () {
    return a;
  }), n.d(t, "f", function () {
    return u;
  }), n.d(t, "e", function () {
    return c;
  });
  n(23), n(24), n(3);
  var r = Symbol.for("TelemetryClient"),
      o = Symbol.for("TelemetryClientFactory"),
      i = Symbol.for("TelemetryEventGroup"),
      a = Symbol.for("TelemetryEventGroupFactory"),
      u = Symbol.for("TelemetryProcessor"),
      c = Symbol.for("TelemetryOptions");
}, function (e, t, n) {
  "use strict";

  n.d(t, "c", function () {
    return o.b;
  }), n.d(t, "b", function () {
    return o.a;
  }), n.d(t, "a", function () {
    return r;
  });
  var r,
      o = n(41);
  !function (e) {
    e.TokenMaxLifetimeReached = "tokenMaxLifetimeReached", e.TokenAutoUpdateFailed = "tokenAutoUpdateFailed";
  }(r || (r = {}));
}, function (e, t, n) {
  "use strict";

  (function (e, r) {
    n.d(t, "d", function () {
      return u;
    }), n.d(t, "b", function () {
      return c;
    }), n.d(t, "e", function () {
      return s;
    }), n.d(t, "c", function () {
      return l;
    }), n.d(t, "a", function () {
      return f;
    });
    n(23), n(24), n(71), n(5), n(128), n(129), n(3), n(6), n(93), n(7);
    var o = n(1),
        i = n(2);

    function a(e) {
      return (a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function u(t, n) {
      if ("object" !== a(t) || null === t || Array.isArray(t)) {
        var u = {
          module: Object(i.b)(e),
          severity: o.b.Error,
          source: Object(i.a)(r)
        };
        throw new o.c(o.a.InvalidParams, u, "".concat(n, ", expected an object"));
      }
    }

    function c(t, n) {
      if (u(t, n), function (e) {
        try {
          JSON.stringify(e);
        } catch (e) {
          return /^TypeError: Converting circular structure to JSON/.test(e);
        }

        return !1;
      }(t)) {
        var a = {
          module: Object(i.b)(e),
          severity: o.b.Error,
          source: Object(i.a)(r)
        };
        throw new o.c(o.a.InvalidParams, a, "".concat(n, ", expected an object without cycles"));
      }
    }

    function s(t, n) {
      if ("string" != typeof t) {
        var a = {
          module: Object(i.b)(e),
          severity: o.b.Error,
          source: Object(i.a)(r)
        };
        throw new o.c(o.a.InvalidParams, a, "".concat(n, ", expected a string"));
      }
    }

    function l(t, n) {
      if (s(t, n), "" === t.trim()) {
        var a = {
          module: Object(i.b)(e),
          severity: o.b.Error,
          source: Object(i.a)(r)
        };
        throw new o.c(o.a.InvalidParams, a, "".concat(n, ", expected a string which is not empty"));
      }
    }

    function f(t, n) {
      if (!(t in n)) {
        var a = {
          module: Object(i.b)(e),
          severity: o.b.Error,
          source: Object(i.a)(r)
        };
        throw new o.c(o.a.InvalidParams, a, "".concat(t, " is not a valid key"));
      }
    }
  }).call(this, "/", "/index.js");
}, function (e, t, n) {
  "use strict";

  n.d(t, "b", function () {
    return r;
  }), n.d(t, "f", function () {
    return o;
  }), n.d(t, "e", function () {
    return i;
  }), n.d(t, "a", function () {
    return a;
  }), n.d(t, "d", function () {
    return u;
  }), n.d(t, "c", function () {
    return c;
  });
  n(23), n(24), n(3);
  var r = Symbol.for("loggerFactory"),
      o = Symbol.for("NewableLogger"),
      i = Symbol.for("loglevelFactory"),
      a = Symbol.for("loggerDefaultPlugins"),
      u = Symbol.for("LoggerOptions"),
      c = Symbol.for("LoggerInstances");
}, function (e, t, n) {
  "use strict";

  n.d(t, "d", function () {
    return r;
  }), n.d(t, "a", function () {
    return o;
  }), n.d(t, "b", function () {
    return i;
  }), n.d(t, "f", function () {
    return a;
  }), n.d(t, "e", function () {
    return u;
  }), n.d(t, "c", function () {
    return c;
  });
  n(23), n(24), n(3);
  var r = Symbol.for("Authenticator"),
      o = Symbol.for("AuthenticatorDataContainer"),
      i = Symbol.for("AuthenticatorFactory"),
      a = Symbol.for("TwilioIdpUrl"),
      u = Symbol.for("twilioIdpUrlMockOptions"),
      c = Symbol.for("authenticatorMockOptions");
}, function (e, t) {
  e.exports = require("core-js/modules/es.array.concat.js");
}, function (e, t) {
  e.exports = require("core-js/modules/es.symbol.js");
}, function (e, t) {
  e.exports = require("core-js/modules/es.symbol.description.js");
}, function (e, t, n) {
  "use strict";

  n.d(t, "d", function () {
    return r;
  }), n.d(t, "e", function () {
    return o;
  }), n.d(t, "c", function () {
    return i;
  }), n.d(t, "a", function () {
    return a;
  }), n.d(t, "b", function () {
    return u;
  });
  n(23), n(24), n(3);
  var r = Symbol.for("RealtimeStats"),
      o = Symbol.for("TasksByTimeFactory"),
      i = Symbol.for("QueueStatsProvider"),
      a = Symbol.for("NewableQueueStats"),
      u = Symbol.for("NewableTasksByTime");
}, function (e, t, n) {
  "use strict";

  var r, o;

  function i(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  n.d(t, "a", function () {
    return o;
  }), n.d(t, "b", function () {
    return a;
  }), function (e) {
    e[e.Forbidden = 45502] = "Forbidden", e[e.InvalidParams = 45503] = "InvalidParams", e[e.InvalidState = 45505] = "InvalidState", e[e.NotFound = 45504] = "NotFound", e[e.SDK = 45500] = "SDK", e[e.Unknown = 45501] = "Unknown", e[e.BadRequest = 70002] = "BadRequest", e[e.InvalidCertificate = 70251] = "InvalidCertificate", e[e.InvalidAccessToken = 20101] = "InvalidAccessToken", e[e.AccessTokenExpired = 20104] = "AccessTokenExpired", e[e.ValidationError = 45004] = "ValidationError", e[e.AuthorizationError = 45003] = "AuthorizationError", e[e.PermissionDeniedError = 20003] = "PermissionDeniedError", e[e.TwilsockConnectionError = 45511] = "TwilsockConnectionError", e[e.ConnectionError = 45011] = "ConnectionError", e[e.TooManyRequests = 20429] = "TooManyRequests";
  }(o || (o = {}));
  var a = (i(r = {}, o.TwilsockConnectionError, "Twilsock connection error"), i(r, o.Forbidden, "User is not authorized to perform the requested operation"), i(r, o.InvalidParams, "Invalid parameters"), i(r, o.InvalidState, "Invalid state"), i(r, o.NotFound, "Resource not found"), i(r, o.SDK, "Something went wrong, error from inner SDK"), i(r, o.Unknown, "Unknown error"), i(r, o.ValidationError, "Validation error: request body validation fails"), i(r, o.AuthorizationError, "Attempt to access resource where access is not allowed for given credentials"), i(r, o.ConnectionError, "Connection error"), i(r, o.InvalidAccessToken, "Invalid Access Token"), i(r, o.AccessTokenExpired, "Access Token expired or expiration date invalid"), i(r, o.TooManyRequests, "TooManyRequests: Twilsock rate limit exceeded"), i(r, o.BadRequest, "BadRequest: The data in the request is unparsable"), i(r, o.InvalidCertificate, "Validation error: invalid certificate"), i(r, o.PermissionDeniedError, "PermissionDeniedError: You lack permission to the resource and method you requested"), r);
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return r;
  }), n.d(t, "b", function () {
    return o;
  }), n.d(t, "d", function () {
    return i;
  }), n.d(t, "c", function () {
    return a;
  });
  n(23), n(24), n(3);
  var r = Symbol.for("NewableTwilsockClient"),
      o = Symbol.for("ProductID"),
      i = Symbol.for("Twilsock"),
      a = Symbol.for("TwilsockClientFactory");
}, function (e, t, n) {
  "use strict";

  var r, o;

  function i(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  n.d(t, "a", function () {
    return o;
  }), n.d(t, "b", function () {
    return a;
  }), function (e) {
    e[e.SyncConnectionError = 45510] = "SyncConnectionError", e[e.SyncAccessForbiddenError = 54007] = "SyncAccessForbiddenError", e[e.SyncMapNotFoundError = 54200] = "SyncMapNotFoundError", e[e.SyncMapItemNotFoundError = 54201] = "SyncMapItemNotFoundError", e[e.SyncInvalidMapItemDataError = 54206] = "SyncInvalidMapItemDataError", e[e.SyncInvalidMapItemKeyError = 54209] = "SyncInvalidMapItemKeyError", e[e.SyncNameNotFoundError = 54300] = "SyncNameNotFoundError", e[e.SyncNameAlreadyExistsError = 54301] = "SyncNameAlreadyExistsError", e[e.SyncInvalidNameError = 54302] = "SyncInvalidNameError";
  }(o || (o = {}));
  var a = (i(r = {}, o.SyncConnectionError, "Sync connection error"), i(r, o.SyncAccessForbiddenError, "Sync access forbidden for identity"), i(r, o.SyncMapNotFoundError, "Sync map not found"), i(r, o.SyncInvalidMapItemDataError, "Invalid sync map item data"), i(r, o.SyncInvalidMapItemKeyError, "Invalid sync map item key"), i(r, o.SyncMapItemNotFoundError, "Sync map item not found"), i(r, o.SyncNameNotFoundError, "Sync unique name not found"), i(r, o.SyncNameAlreadyExistsError, "Sync unique name already exists"), i(r, o.SyncInvalidNameError, "Sync invalid unique name"), r);
}, function (e, t, n) {
  "use strict";

  var r, o, i, a;
  n.d(t, "b", function () {
    return r;
  }), n.d(t, "c", function () {
    return o;
  }), n.d(t, "d", function () {
    return i;
  }), n.d(t, "a", function () {
    return a;
  }), n.d(t, "e", function () {
    return u.a;
  }), n.d(t, "f", function () {
    return u.b;
  }), function (e) {
    e.Default = "default", e.Error = "error";
  }(r || (r = {})), function (e) {
    e.ClientInitialized = "client_initialized", e.ClientDestroyed = "client_destroyed";
  }(o || (o = {})), function (e) {
    e.Client = "Client";
  }(i || (i = {})), function (e) {
    e.TwilioChat = "twilio_chat", e.TwilioSync = "twilio_sync", e.TwilioClient = "twilio_client", e.Twilsock = "twilsock";
  }(a || (a = {}));
  var u = n(37);
}, function (e, t, n) {
  "use strict";

  n.d(t, "e", function () {
    return r;
  }), n.d(t, "b", function () {
    return o;
  }), n.d(t, "d", function () {
    return i;
  }), n.d(t, "a", function () {
    return a;
  }), n.d(t, "c", function () {
    return u;
  }), n.d(t, "g", function () {
    return c;
  }), n.d(t, "f", function () {
    return s;
  });
  n(23), n(24), n(3);
  var r = Symbol.for("EnvironmentConfig"),
      o = Symbol.for("AccountConfig"),
      i = (Symbol.for("AccountConfigData"), Symbol.for("ConfigDataContainer")),
      a = Symbol.for("AccountConfigProvider"),
      u = Symbol.for("AccountConfigUpdater"),
      c = Symbol.for("PublicConfigProvider"),
      s = Symbol.for("PublicConfigMockOptions");
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return o;
  }), n.d(t, "c", function () {
    return r.b;
  }), n.d(t, "b", function () {
    return r.a;
  }), n.d(t, "d", function () {
    return r.d;
  }), n.d(t, "e", function () {
    return r.e;
  });
  n(55);
  var r = n(17);

  function o(e, t) {
    var n = e.get(r.b);
    return n.name = t, n;
  }
}, function (e, t, n) {
  "use strict";

  n.d(t, "b", function () {
    return r;
  }), n.d(t, "c", function () {
    return o;
  });
  var r,
      o,
      i = n(63);
  n.d(t, "a", function () {
    return i.SyncClient;
  }), function (e) {
    e.ConnectionStateChanged = "connectionStateChanged";
  }(r || (r = {})), function (e) {
    e.Connected = "connected", e.Error = "error", e.Disconnected = "disconnected", e.Denied = "denied";
  }(o || (o = {}));
}, function (e, t, n) {
  "use strict";

  var r = n(21);
  n.d(t, "b", function () {
    return r.d;
  }), n.d(t, "a", function () {
    return r.b;
  }), n.d(t, "c", function () {
    return r.f;
  });
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return r;
  }), n.d(t, "d", function () {
    return o;
  }), n.d(t, "b", function () {
    return i;
  }), n.d(t, "c", function () {
    return a;
  });
  n(23), n(24), n(3);
  var r = Symbol.for("reThrowErrorWithCustomMessage"),
      o = Symbol.for("throwError"),
      i = Symbol.for("throwErrorFromErrorResponse"),
      a = Symbol.for("throwErrorFromResponse");
}, function (e, t, n) {
  "use strict";

  n.d(t, "b", function () {
    return b;
  }), n.d(t, "d", function () {
    return y;
  }), n.d(t, "c", function () {
    return m;
  }), n.d(t, "a", function () {
    return w;
  });
  n(23), n(24), n(71), n(39), n(5), n(3), n(6), n(40), n(7);
  var r = n(88),
      o = n.n(r),
      i = n(89),
      a = n.n(i),
      u = n(105),
      c = n.n(u),
      s = n(106),
      l = n.n(s),
      f = n(19);

  function d(e) {
    return (d = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  var p = function e(t, n) {
    var r = [];
    return t.forEach(function (t) {
      var o;
      o = Array.isArray(t) ? e(t, n) : "object" === d(t) ? v(t, n) : t, r.push(o);
    }), r;
  },
      v = function e(t, n) {
    return l()(t, function (t, r, o) {
      Array.isArray(r) ? t["".concat(n(o))] = p(r, n) : r instanceof Object && !(r instanceof Date) ? t["".concat(n(o))] = e(r, n) : t["".concat(n(o))] = r;
    }, {});
  },
      b = function b(e) {
    return v(e, function (e) {
      return o()(e);
    });
  },
      h = function h(e, t) {
    return c()(e, function (e, n) {
      return t(n);
    });
  },
      y = function y(e) {
    return h(e, function (e) {
      return a()(e);
    });
  },
      m = function m(e) {
    return h(e, function (e) {
      return o()(e);
    });
  },
      w = function w(e) {
    return Object(f.b)(e, "key-value dictionary"), v(e, function (e) {
      return a()(e);
    });
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "b", function () {
    return r;
  });
  var r,
      o = n(95);
  n.d(t, "a", function () {
    return o.TwilsockClient;
  }), function (e) {
    e.TokenExpired = "tokenExpired", e.TokenAboutToExpire = "tokenAboutToExpire", e.StateChanged = "stateChanged", e.ConnectionError = "connectionError", e.Connected = "connected", e.Disconnected = "disconnected";
  }(r || (r = {}));
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return r;
  }), n.d(t, "b", function () {
    return o;
  });
  n(23), n(24), n(3);
  var r = Symbol.for("TelemetrySdkClient"),
      o = Symbol.for("TelemetrySdkErrorEventGroup");
}, function (e, t, n) {
  "use strict";

  n.d(t, "c", function () {
    return a;
  }), n.d(t, "d", function () {
    return u;
  }), n.d(t, "a", function () {
    return c;
  }), n.d(t, "b", function () {
    return s;
  });
  n(127), n(5), n(54), n(3), n(91), n(6), n(7);
  var r = n(26),
      o = n(28),
      i = new Map([[o.a.SyncConnectionError, r.a.ConnectionError], [o.a.SyncAccessForbiddenError, r.a.Forbidden], [o.a.SyncMapNotFoundError, r.a.NotFound], [o.a.SyncMapItemNotFoundError, r.a.NotFound], [o.a.SyncInvalidMapItemDataError, r.a.InvalidParams], [o.a.SyncInvalidMapItemKeyError, r.a.InvalidParams], [o.a.SyncNameNotFoundError, r.a.NotFound], [o.a.SyncNameAlreadyExistsError, r.a.InvalidState], [o.a.SyncInvalidNameError, r.a.InvalidParams]]);

  function a(e) {
    return !!Object.values(o.a).find(function (t) {
      return t === e;
    });
  }

  function u(e) {
    return function (e) {
      return !!Object.values(r.a).find(function (t) {
        return t === e;
      });
    }(e) || a(e);
  }

  function c(e) {
    return function (e) {
      return r.b[e];
    }(e) || function (e) {
      return o.b[e];
    }(e) || "Error";
  }

  function s(e) {
    return i.get(e) || r.a.Unknown;
  }
}, function (e, t) {
  e.exports = require("core-js/modules/es.array.for-each.js");
}, function (e, t) {
  e.exports = require("core-js/modules/web.dom-collections.for-each.js");
}, function (e, t, n) {
  "use strict";

  n.d(t, "b", function () {
    return r;
  }), n.d(t, "a", function () {
    return o;
  });
  n(23), n(24), n(3);
  var r = Symbol.for("Session"),
      o = Symbol.for("SessionOptions");
}, function (e, t) {
  e.exports = require("core-js/modules/es.regexp.exec.js");
}, function (e, t, n) {
  "use strict";

  n.d(t, "d", function () {
    return r;
  }), n.d(t, "c", function () {
    return o;
  }), n.d(t, "b", function () {
    return i;
  }), n.d(t, "a", function () {
    return a;
  });
  n(23), n(24), n(3);
  var r = Symbol.for("Client"),
      o = Symbol.for("ClientProvider"),
      i = Symbol.for("ClientOptions"),
      a = Symbol.for("ClientMockOptions");
}, function (e, t, n) {
  "use strict";

  var r, o, i;
  n.d(t, "a", function () {
    return r;
  }), n.d(t, "b", function () {
    return o;
  }), n.d(t, "c", function () {
    return i;
  }), function (e) {
    e.Client = "flex:Client", e.Error = "flex:Error", e.Session = "flex:Session", e.Twilsock = "flex:Twilsock", e.Auth = "flex:Auth", e.Config = "flex:Config", e.Sync = "flex:Sync", e.SyncAdapter = "flex:SyncAdapter", e.QueueStats = "flex:QueueStats";
  }(r || (r = {})), function (e) {
    e.TwilioChat = "twilio-chat", e.TwilioSync = "twilio-sync", e.Twilsock = "twilsock";
  }(o || (o = {})), function (e) {
    e.TelemetryClient = "TelemetryClient", e.TelemetryProcessor = "TelemetryProcessor", e.TelemetrySdkClient = "TelemetrySdkClient";
  }(i || (i = {}));
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return k;
  });
  n(22), n(5), n(3), n(6), n(11), n(7);
  var r = n(38),
      o = n(61);

  function i(e) {
    return (i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function a(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function u(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  function c(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  function s(e, t) {
    return !t || "object" !== i(t) && "function" != typeof t ? l(e) : t;
  }

  function l(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }

  function f(e) {
    var t = "function" == typeof Map ? new Map() : void 0;
    return (f = function f(e) {
      if (null === e || (n = e, -1 === Function.toString.call(n).indexOf("[native code]"))) return e;
      var n;
      if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");

      if (void 0 !== t) {
        if (t.has(e)) return t.get(e);
        t.set(e, r);
      }

      function r() {
        return d(e, arguments, b(this).constructor);
      }

      return r.prototype = Object.create(e.prototype, {
        constructor: {
          value: r,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), v(r, e);
    })(e);
  }

  function d(e, t, n) {
    return (d = p() ? Reflect.construct : function (e, t, n) {
      var r = [null];
      r.push.apply(r, t);
      var o = new (Function.bind.apply(e, r))();
      return n && v(o, n.prototype), o;
    }).apply(null, arguments);
  }

  function p() {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }

  function v(e, t) {
    return (v = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  function b(e) {
    return (b = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function h(e, t) {
    var n = t.get(e);
    if (!n) throw new TypeError("attempted to get private field on non-instance");
    return n.get ? n.get.call(e) : n.value;
  }

  function y(e, t, n) {
    var r = t.get(e);
    if (!r) throw new TypeError("attempted to set private field on non-instance");
    if (r.set) r.set.call(e, n);else {
      if (!r.writable) throw new TypeError("attempted to set read only private field");
      r.value = n;
    }
    return n;
  }

  var m = new WeakMap(),
      w = new WeakMap(),
      g = new WeakMap(),
      j = new WeakMap(),
      k = function (e) {
    !function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && v(e, t);
    }(O, e);
    var t,
        n,
        i,
        f,
        d,
        k = (t = O, n = p(), function () {
      var e,
          r = b(t);

      if (n) {
        var o = b(this).constructor;
        e = Reflect.construct(r, arguments, o);
      } else e = r.apply(this, arguments);

      return s(this, e);
    });

    function O(e, t, n, i) {
      var a;
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, O), a = k.call(this, "".concat(Object(r.a)(e) + (void 0 !== n ? ": ".concat(n) : ""), " (").concat(e, ")")), m.set(l(a), {
        writable: !0,
        value: void 0
      }), w.set(l(a), {
        writable: !0,
        value: void 0
      }), g.set(l(a), {
        writable: !0,
        value: void 0
      }), j.set(l(a), {
        writable: !0,
        value: void 0
      }), y(l(a), w, e), y(l(a), m, n), y(l(a), j, t || {
        severity: o.a.Error
      }), y(l(a), g, i), Object.setPrototypeOf(l(a), O.prototype), a;
    }

    return i = O, (f = [{
      key: "code",
      get: function get() {
        return h(this, w);
      }
    }, {
      key: "details",
      get: function get() {
        return h(this, m);
      }
    }, {
      key: "wrappedError",
      get: function get() {
        return h(this, g);
      }
    }, {
      key: "metadata",
      get: function get() {
        return function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? a(Object(n), !0).forEach(function (t) {
              u(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : a(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }

          return e;
        }({}, h(this, j));
      }
    }]) && c(i.prototype, f), d && c(i, d), O;
  }(f(Error));
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return Rn;
  }), n.d(t, "b", function () {
    return Mn;
  });
  n(124);
  var r = n(0),
      o = n(21),
      i = n(100),
      a = n(33);
  n(22);
  var u = n(9);
  var c, s;
  n(5), n(3), n(6), n(11), n(7);

  function l(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  var f,
      d,
      p,
      v,
      b,
      h,
      y,
      m,
      w,
      g,
      j,
      k,
      O,
      S,
      x,
      E = Object(r.injectable)()((s = new WeakMap(), c = function () {
    function e() {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e), s.set(this, {
        writable: !0,
        value: void 0
      });
    }

    var t, n, r;
    return t = e, (n = [{
      key: "accountSid",
      get: function get() {
        return function (e, t) {
          var n = t.get(e);
          if (!n) throw new TypeError("attempted to get private field on non-instance");
          return n.get ? n.get.call(e) : n.value;
        }(this, s);
      },
      set: function set(e) {
        !function (e, t, n) {
          var r = t.get(e);
          if (!r) throw new TypeError("attempted to set private field on non-instance");
          if (r.set) r.set.call(e, n);else {
            if (!r.writable) throw new TypeError("attempted to set read only private field");
            r.value = n;
          }
        }(this, s, e);
      }
    }]) && l(t.prototype, n), r && l(t, r), e;
  }())) || c,
      T = new r.ContainerModule(function (e) {
    e(o.d).to(i.a), e(o.a).to(E).inSingletonScope(), e(o.b).toFactory(function (e) {
      return function (t) {
        return function (e, t) {
          return e.get(o.a).accountSid = t, e.get(a.b);
        }(e.container, t);
      };
    }), e(o.f).toDynamicValue(function (e) {
      return function (t) {
        return function (e, t) {
          var n = e.get(u.d).twilioServiceLoginUrl;
          return t ? "".concat(n, "?localPort=").concat(t) : n;
        }(e.container, t);
      };
    });
  }),
      P = n(41),
      C = (n(13), n(8), n(18)),
      R = n(10),
      M = n(1),
      I = n(4),
      A = n(15);

  function W(e, t, n, r, o, i, a) {
    try {
      var u = e[i](a),
          c = u.value;
    } catch (e) {
      return void n(e);
    }

    u.done ? t(c) : Promise.resolve(c).then(r, o);
  }

  function D(e) {
    return function () {
      var t = this,
          n = arguments;
      return new Promise(function (r, o) {
        var i = e.apply(t, n);

        function a(e) {
          W(i, r, o, a, u, "next", e);
        }

        function u(e) {
          W(i, r, o, a, u, "throw", e);
        }

        a(void 0);
      });
    };
  }

  function F(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  function q(e, t) {
    var n = t.get(e);
    if (!n) throw new TypeError("attempted to get private field on non-instance");
    return n.get ? n.get.call(e) : n.value;
  }

  function N(e, t, n) {
    var r = t.get(e);
    if (!r) throw new TypeError("attempted to set private field on non-instance");
    if (r.set) r.set.call(e, n);else {
      if (!r.writable) throw new TypeError("attempted to set read only private field");
      r.value = n;
    }
    return n;
  }

  var U,
      _,
      L,
      V,
      K,
      z,
      B,
      H,
      G,
      J,
      Q,
      $ = Object(r.injectable)()((d = new WeakMap(), p = new WeakMap(), v = new WeakMap(), b = new WeakMap(), h = new WeakMap(), y = new WeakMap(), m = new WeakMap(), w = new WeakMap(), g = new WeakMap(), j = new WeakMap(), k = new WeakMap(), O = new WeakMap(), S = new WeakMap(), x = new WeakMap(), f = function () {
    function e(t, n, r, o, i, a) {
      var u,
          c,
          s = this;
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e), d.set(this, {
        writable: !0,
        value: void 0
      }), p.set(this, {
        writable: !0,
        value: void 0
      }), v.set(this, {
        writable: !0,
        value: void 0
      }), b.set(this, {
        writable: !0,
        value: void 0
      }), h.set(this, {
        writable: !0,
        value: void 0
      }), y.set(this, {
        writable: !0,
        value: void 0
      }), m.set(this, {
        writable: !0,
        value: void 0
      }), w.set(this, {
        writable: !0,
        value: []
      }), g.set(this, {
        writable: !0,
        value: !0
      }), j.set(this, {
        writable: !0,
        value: void 0
      }), k.set(this, {
        writable: !0,
        value: void 0
      }), O.set(this, {
        writable: !0,
        value: void 0
      }), S.set(this, {
        writable: !0,
        value: (u = D(_regeneratorRuntime.mark(function e() {
          return _regeneratorRuntime.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (!q(s, d)) {
                    e.next = 5;
                    break;
                  }

                  return e.next = 3, q(s, x).call(s);

                case 3:
                  e.next = 6;
                  break;

                case 5:
                  N(s, k, !0);

                case 6:
                case "end":
                  return e.stop();
              }
            }
          }, e);
        })), function () {
          return u.apply(this, arguments);
        })
      }), x.set(this, {
        writable: !0,
        value: (c = D(_regeneratorRuntime.mark(function e() {
          var t, n, r, o, i;
          return _regeneratorRuntime.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (q(s, j).debug("Auto-updating token"), t = q(s, d).get("accountSid")) {
                    e.next = 4;
                    break;
                  }

                  throw new M.d("Account sid not set");

                case 4:
                  return o = q(s, p).call(s, t), e.prev = 5, e.next = 8, o.refreshToken(s.token);

                case 8:
                  i = e.sent, (r = i.dateExpired).getTime() === q(s, b).getTime() && (q(s, j).warn("Token expiration not extended, because max lifetime reached"), q(s, O).emit(C.a.TokenMaxLifetimeReached, i.dateExpired)), n = i.token, e.next = 18;
                  break;

                case 14:
                  e.prev = 14, e.t0 = e.catch(5), q(s, j).error("Failed to refresh token", e.t0), q(s, O).emit(C.a.TokenAutoUpdateFailed);

                case 18:
                  if (q(s, g)) {
                    e.next = 21;
                    break;
                  }

                  return q(s, j).trace("AutoUpdateToken, session destroyed after refreshToken"), e.abrupt("return");

                case 21:
                  if (!n || !r) {
                    e.next = 33;
                    break;
                  }

                  return e.prev = 22, e.next = 25, s.updateToken(n);

                case 25:
                  N(s, b, r), q(s, j).info("Token auto-updated"), e.next = 33;
                  break;

                case 29:
                  e.prev = 29, e.t1 = e.catch(22), q(s, j).error("Failed to auto-update token", e.t1), q(s, O).emit(C.a.TokenAutoUpdateFailed);

                case 33:
                case "end":
                  return e.stop();
              }
            }
          }, e, null, [[5, 14], [22, 29]]);
        })), function () {
          return c.apply(this, arguments);
        })
      }), N(this, h, t), N(this, y, n), N(this, m, o), N(this, p, r), N(this, j, i(I.b.Session)), q(this, j).debug("Session constructed"), N(this, O, a);
    }

    var t, n, o, i, c, s;
    return e = Object(r.inject)(A.a)(e, void 0, 5) || e, e = Object(r.inject)(I.d)(e, void 0, 4) || e, e = Object(r.inject)(u.a)(e, void 0, 3) || e, e = Object(r.inject)(a.a)(e, void 0, 2) || e, e = Object(r.inject)(C.b)(e, void 0, 1) || e, e = Object(r.inject)(R.b)(e, void 0, 0) || e, t = e, (n = [{
      key: "init",
      value: (s = D(_regeneratorRuntime.mark(function e(t) {
        var n, r, o;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return q(this, j).debug("will initialize session with token: ", t), q(this, j).debug("will update token: ", q(this, y).autoUpdateToken), N(this, v, t), e.next = 5, q(this, h).connect(t);

              case 5:
                return q(this, y).autoUpdateToken && q(this, h).on(R.a.TokenAboutToExpire, q(this, S)), e.t0 = N, e.t1 = this, e.t2 = d, e.next = 11, q(this, m).call(this);

              case 11:
                return e.t3 = e.sent, (0, e.t0)(e.t1, e.t2, e.t3), n = q(this, d).get("accountSid"), r = q(this, p).call(this, n), e.next = 17, r.validateToken(q(this, v));

              case 17:
                if (o = e.sent, N(this, w, o.roles), N(this, b, o.dateExpired), !q(this, k)) {
                  e.next = 23;
                  break;
                }

                return e.next = 23, q(this, x).call(this);

              case 23:
                return e.abrupt("return", Promise.resolve());

              case 24:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (e) {
        return s.apply(this, arguments);
      })
    }, {
      key: "updateToken",
      value: (c = D(_regeneratorRuntime.mark(function e(t) {
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.next = 2, q(this, h).updateToken(t);

              case 2:
                N(this, v, t), q(this, j).debug("new token set");

              case 4:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (e) {
        return c.apply(this, arguments);
      })
    }, {
      key: "destroy",
      value: (i = D(_regeneratorRuntime.mark(function e() {
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return N(this, g, !1), q(this, h).removeListener(R.a.TokenAboutToExpire, q(this, S)), e.next = 4, q(this, h).destroy();

              case 4:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return i.apply(this, arguments);
      })
    }, {
      key: "token",
      get: function get() {
        return q(this, v);
      }
    }, {
      key: "roles",
      get: function get() {
        return q(this, w);
      }
    }, {
      key: "on",
      value: function value(e, t) {
        return q(this, O).on(e, t), this;
      }
    }, {
      key: "removeListener",
      value: function value(e, t) {
        return q(this, O).removeListener(e, t), this;
      }
    }]) && F(t.prototype, n), o && F(t, o), e;
  }())) || f,
      Y = n(75),
      X = new r.ContainerModule(function (e) {
    e(P.b).to($).inSingletonScope(), e(P.a).toConstantValue(Object(Y.a)());
  }),
      Z = n(14),
      ee = (n(90), n(31)),
      te = n(29),
      ne = n(48),
      re = n(53);

  function oe(e, t, n, r, o, i, a) {
    try {
      var u = e[i](a),
          c = u.value;
    } catch (e) {
      return void n(e);
    }

    u.done ? t(c) : Promise.resolve(c).then(r, o);
  }

  function ie(e) {
    return function () {
      var t = this,
          n = arguments;
      return new Promise(function (r, o) {
        var i = e.apply(t, n);

        function a(e) {
          oe(i, r, o, a, u, "next", e);
        }

        function u(e) {
          oe(i, r, o, a, u, "throw", e);
        }

        a(void 0);
      });
    };
  }

  function ae(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  function ue(e, t) {
    var n = t.get(e);
    if (!n) throw new TypeError("attempted to get private field on non-instance");
    return n.get ? n.get.call(e) : n.value;
  }

  function ce(e, t, n) {
    var r = t.get(e);
    if (!r) throw new TypeError("attempted to set private field on non-instance");
    if (r.set) r.set.call(e, n);else {
      if (!r.writable) throw new TypeError("attempted to set read only private field");
      r.value = n;
    }
    return n;
  }

  function se(e, t, n, r, o) {
    var i = {};
    return Object.keys(r).forEach(function (e) {
      i[e] = r[e];
    }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = n.slice().reverse().reduce(function (n, r) {
      return r(e, t, n) || n;
    }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
  }

  var le = (U = Object(r.injectable)(), _ = Object(r.postConstruct)(), U((K = new WeakMap(), z = new WeakMap(), B = new WeakMap(), H = new WeakMap(), G = new WeakMap(), J = new WeakMap(), Q = new WeakMap(), se((V = function () {
    function e(t, n, r, o, i, a, u, c) {
      var s,
          l = this;
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e), K.set(this, {
        writable: !0,
        value: void 0
      }), z.set(this, {
        writable: !0,
        value: void 0
      }), B.set(this, {
        writable: !0,
        value: void 0
      }), H.set(this, {
        writable: !0,
        value: void 0
      }), G.set(this, {
        writable: !0,
        value: void 0
      }), J.set(this, {
        writable: !0,
        value: void 0
      }), Q.set(this, {
        writable: !0,
        value: (s = ie(_regeneratorRuntime.mark(function e() {
          var t, n;
          return _regeneratorRuntime.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return e.prev = 0, t = ue(l, G), n = t.createEventGroup(te.b.Default), e.next = 5, n.addEvents({
                    eventName: te.c.ClientDestroyed,
                    eventSource: te.d.Client
                  });

                case 5:
                  e.next = 10;
                  break;

                case 7:
                  e.prev = 7, e.t0 = e.catch(0), ue(l, B).error("Failed to send telemetry destroy event", e.t0);

                case 10:
                case "end":
                  return e.stop();
              }
            }
          }, e, null, [[0, 7]]);
        })), function () {
          return s.apply(this, arguments);
        })
      }), ce(this, K, t), ce(this, z, n), this.config = {
        account: r
      }, ce(this, H, o), this.realtimeStats = i, ce(this, G, a), ce(this, B, u(I.b.Client)), ce(this, J, c);
    }

    var t, n, o, i, a;
    return e = Object(r.inject)(A.a)(e, void 0, 7) || e, e = Object(r.inject)(I.d)(e, void 0, 6) || e, e = Object(r.inject)(te.e)(e, void 0, 5) || e, e = Object(r.inject)(ne.c)(e, void 0, 4) || e, e = Object(r.inject)(ee.b)(e, void 0, 3) || e, e = Object(r.inject)(u.b)(e, void 0, 2) || e, e = Object(r.inject)(R.b)(e, void 0, 1) || e, e = Object(r.inject)(C.c)(e, void 0, 0) || e, t = e, (n = [{
      key: "setupProxies",
      value: function value() {
        Object(A.b)(ue(this, z), ue(this, J), R.a.TokenAboutToExpire, Z.a.TokenAboutToExpire), Object(A.b)(ue(this, z), ue(this, J), R.a.TokenExpired, Z.a.TokenExpired), Object(A.b)(ue(this, z), ue(this, J), R.a.TokenUpdated, Z.a.TokenUpdated), Object(A.b)(ue(this, z), ue(this, J), R.a.ConnectionError, Z.a.ConnectionLost), Object(A.b)(ue(this, z), ue(this, J), R.a.Connected, Z.a.ConnectionRestored), Object(A.b)(ue(this, z), ue(this, J), R.a.Disconnected, Z.a.Disconnected), Object(A.b)(ue(this, K), ue(this, J), C.a.TokenAutoUpdateFailed, Z.a.TokenAutoUpdateFailed), Object(A.b)(ue(this, K), ue(this, J), C.a.TokenMaxLifetimeReached, Z.a.TokenMaxLifetimeReached);
      }
    }, {
      key: "updateToken",
      value: (a = ie(_regeneratorRuntime.mark(function e(t) {
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.next = 2, ue(this, K).updateToken(t);

              case 2:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (e) {
        return a.apply(this, arguments);
      })
    }, {
      key: "destroy",
      value: (i = ie(_regeneratorRuntime.mark(function e() {
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.next = 2, ue(this, Q).call(this);

              case 2:
                return ue(this, B).debug("client log out"), e.next = 5, ue(this, K).destroy();

              case 5:
                ue(this, J).removeAllListeners();

              case 6:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return i.apply(this, arguments);
      })
    }, {
      key: "roles",
      get: function get() {
        return ue(this, K).roles;
      }
    }, {
      key: "token",
      get: function get() {
        return ue(this, K).token;
      }
    }, {
      key: "createTelemetryClient",
      value: function value(e) {
        return ue(this, H).call(this, e);
      }
    }, {
      key: "on",
      value: function value(e, t) {
        return ue(this, J).on(e, t), this;
      }
    }, {
      key: "removeListener",
      value: function value(e, t) {
        return ue(this, J).removeListener(e, t), this;
      }
    }]) && ae(t.prototype, n), o && ae(t, o), e;
  }()).prototype, "setupProxies", [_], Object.getOwnPropertyDescriptor(V.prototype, "setupProxies"), V.prototype), se(V.prototype, "roles", [re.a], Object.getOwnPropertyDescriptor(V.prototype, "roles"), V.prototype), se(V.prototype, "token", [re.a], Object.getOwnPropertyDescriptor(V.prototype, "token"), V.prototype), L = V)) || L),
      fe = n(76),
      de = n(77),
      pe = new r.ContainerModule(function (e) {
    e(Z.b).to(de.a).inSingletonScope(), e(Z.d).to(le).inSingletonScope(), e(Z.c).toProvider(function (e) {
      return function (t, n) {
        return Object(fe.a)(e.container, t, n);
      };
    });
  }),
      ve = n(34),
      be = n(26),
      he = n(38),
      ye = n(45);

  function me(e, t, n, r, o, i, a) {
    try {
      var u = e[i](a),
          c = u.value;
    } catch (e) {
      return void n(e);
    }

    u.done ? t(c) : Promise.resolve(c).then(r, o);
  }

  function we(e) {
    return function () {
      var t = this,
          n = arguments;
      return new Promise(function (r, o) {
        var i = e.apply(t, n);

        function a(e) {
          me(i, r, o, a, u, "next", e);
        }

        function u(e) {
          me(i, r, o, a, u, "throw", e);
        }

        a(void 0);
      });
    };
  }

  function ge() {
    return (ge = we(_regeneratorRuntime.mark(function e(t, n) {
      var r, o, i, a;
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.prev = 0, o = t.get(te.f), i = n.wrappedError, e.next = 5, o.addErrorEvent({
                eventName: "error_reported",
                error: {
                  code: n.code,
                  message: n.message,
                  module: n.metadata.module,
                  reporter: "flex-sdk",
                  resourceSid: n.metadata.resourceSid,
                  severity: n.metadata.severity,
                  source: n.metadata.source || "flex-sdk",
                  stackTrace: n.stack,
                  unhandled: n.metadata.unhandled,
                  wrappedErrorCode: null == i ? void 0 : i.code,
                  wrappedErrorMessage: null !== (r = null == i ? void 0 : i.message) && void 0 !== r ? r : void 0
                }
              });

            case 5:
              e.next = 12;
              break;

            case 7:
              e.prev = 7, e.t0 = e.catch(0), a = t.get(I.d), a(I.b.Error).debug("Failed to report the error", e.t0);

            case 12:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[0, 7]]);
    }))).apply(this, arguments);
  }

  function je(e, t, n, r, o, i, a) {
    try {
      var u = e[i](a),
          c = u.value;
    } catch (e) {
      return void n(e);
    }

    u.done ? t(c) : Promise.resolve(c).then(r, o);
  }

  function ke(e) {
    return function () {
      var t = this,
          n = arguments;
      return new Promise(function (r, o) {
        var i = e.apply(t, n);

        function a(e) {
          je(i, r, o, a, u, "next", e);
        }

        function u(e) {
          je(i, r, o, a, u, "throw", e);
        }

        a(void 0);
      });
    };
  }

  function Oe(e, t, n, r, o) {
    if (o instanceof ye.a) throw o;
    t && Object(he.d)(t) || console.warn("Unknown error code");
    var i = t;
    Object(he.c)(t) && (i = Object(he.b)(t));
    var a = new ye.a(i, n, r, o);
    throw function (e, t) {
      ge.apply(this, arguments);
    }(e, a), a;
  }

  function Se(e, t) {
    throw new ye.a(e.code, e.metadata, t, e.wrappedError);
  }

  function xe(e, t, n) {
    if (t instanceof ye.a) throw t;
    Oe(e, t.code ? t.code : be.a.Unknown, n, t.message);
  }

  function Ee() {
    return (Ee = ke(_regeneratorRuntime.mark(function e(t, n, r, o) {
      var i;
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.next = 2, n.json();

            case 2:
              (i = e.sent).message = o || i.message, xe(t, i, r);

            case 5:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }))).apply(this, arguments);
  }

  var Te = new r.ContainerModule(function (e) {
    e(ve.d).toDynamicValue(function (e) {
      return function (t, n, r, o) {
        return Oe(e.container, t, n, r, o);
      };
    }).inSingletonScope(), e(ve.b).toDynamicValue(function (e) {
      return function (t, n) {
        return xe(e.container, t, n);
      };
    }).inSingletonScope(), e(ve.c).toDynamicValue(function (e) {
      return function (t, n, r) {
        return function (e, t, n, r) {
          return Ee.apply(this, arguments);
        }(e.container, t, n, r);
      };
    }).inSingletonScope(), e(ve.a).toConstantValue(Se);
  }),
      Pe = n(49),
      Ce = n(58),
      Re = new r.ContainerModule(function (e) {
    e(Ce.a).toDynamicValue(function () {
      return new Pe.EventEmitter();
    });
  }),
      Me = n(12);

  function Ie(e, t, n, r, o, i, a) {
    try {
      var u = e[i](a),
          c = u.value;
    } catch (e) {
      return void n(e);
    }

    u.done ? t(c) : Promise.resolve(c).then(r, o);
  }

  var Ae = function () {
    var e,
        t = (e = _regeneratorRuntime.mark(function e(t) {
      var n, r, o, i;
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return n = t.get(u.c), r = t.get(Me.a), e.next = 4, r.fetchConfiguration();

            case 4:
              return o = e.sent, n.set(o), i = t.get(u.b), e.abrupt("return", i);

            case 8:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }), function () {
      var t = this,
          n = arguments;
      return new Promise(function (r, o) {
        var i = e.apply(t, n);

        function a(e) {
          Ie(i, r, o, a, u, "next", e);
        }

        function u(e) {
          Ie(i, r, o, a, u, "throw", e);
        }

        a(void 0);
      });
    });
    return function (e) {
      return t.apply(this, arguments);
    };
  }(),
      We = n(30);

  function De(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function Fe(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  var qe,
      Ne,
      Ue,
      _e,
      Le = function Le() {
    var e;
    return function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? De(Object(n), !0).forEach(function (t) {
          Fe(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : De(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }

      return e;
    }({
      authServiceUrl: "https://iam.twilio.com/v1/Accounts",
      twilioServiceLoginUrl: "https://flex.twilio.com/admin"
    }, null === (e = window.__TWILIO_FLEX_SDK__) || void 0 === e ? void 0 : e.environmentConfig);
  },
      Ve = (n(72), n(73), n(19));

  function Ke(e, t) {
    if (null == e) return {};

    var n,
        r,
        o = function (e, t) {
      if (null == e) return {};
      var n,
          r,
          o = {},
          i = Object.keys(e);

      for (r = 0; r < i.length; r++) {
        n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
      }

      return o;
    }(e, t);

    if (Object.getOwnPropertySymbols) {
      var i = Object.getOwnPropertySymbols(e);

      for (r = 0; r < i.length; r++) {
        n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
      }
    }

    return o;
  }

  function ze(e, t, n, r, o, i, a) {
    try {
      var u = e[i](a),
          c = u.value;
    } catch (e) {
      return void n(e);
    }

    u.done ? t(c) : Promise.resolve(c).then(r, o);
  }

  function Be(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  function He(e, t) {
    var n = t.get(e);
    if (!n) throw new TypeError("attempted to get private field on non-instance");
    return n.get ? n.get.call(e) : n.value;
  }

  function Ge(e, t, n) {
    var r = t.get(e);
    if (!r) throw new TypeError("attempted to set private field on non-instance");
    if (r.set) r.set.call(e, n);else {
      if (!r.writable) throw new TypeError("attempted to set read only private field");
      r.value = n;
    }
    return n;
  }

  var Je = Object(r.injectable)()((Ne = new WeakMap(), Ue = new WeakMap(), _e = new WeakMap(), qe = function () {
    function e(t, n) {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e), Ne.set(this, {
        writable: !0,
        value: void 0
      }), Ue.set(this, {
        writable: !0,
        value: void 0
      }), _e.set(this, {
        writable: !0,
        value: void 0
      }), Ge(this, Ne, t), Ge(this, Ue, n);
    }

    var t, n, o, i, a;
    return e = Object(r.inject)(We.c)(e, void 0, 1) || e, e = Object(r.inject)(We.d)(e, void 0, 0) || e, t = e, (n = [{
      key: "get",
      value: function value(e) {
        return He(this, Ne).get()[e];
      }
    }, {
      key: "set",
      value: (i = _regeneratorRuntime.mark(function e(t) {
        var n,
            r,
            o,
            i,
            a,
            u = this;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return n = He(this, Ne).get(), r = n.accountSid, o = Ke(n, ["accountSid"]), Object.keys(t).map(function (e) {
                  return Object(Ve.a)(e, o);
                }), i = function i() {
                  return He(u, Ue).call(u, r, t);
                }, e.next = 6, this.updateInCallOrder(i);

              case 6:
                return a = e.sent, He(this, Ne).set(a), e.abrupt("return", Promise.resolve());

              case 9:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      }), a = function a() {
        var e = this,
            t = arguments;
        return new Promise(function (n, r) {
          var o = i.apply(e, t);

          function a(e) {
            ze(o, n, r, a, u, "next", e);
          }

          function u(e) {
            ze(o, n, r, a, u, "throw", e);
          }

          a(void 0);
        });
      }, function (e) {
        return a.apply(this, arguments);
      })
    }, {
      key: "updateInCallOrder",
      value: function value(e) {
        return He(this, _e) ? Ge(this, _e, He(this, _e).then(function () {
          return e();
        })) : Ge(this, _e, e()), He(this, _e);
      }
    }]) && Be(t.prototype, n), o && Be(t, o), e;
  }())) || qe,
      Qe = n(104);

  function $e(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function Ye(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? $e(Object(n), !0).forEach(function (t) {
        Xe(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : $e(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }

    return e;
  }

  function Xe(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  function Ze(e, t, n, r, o, i, a) {
    try {
      var u = e[i](a),
          c = u.value;
    } catch (e) {
      return void n(e);
    }

    u.done ? t(c) : Promise.resolve(c).then(r, o);
  }

  var et = function () {
    var e,
        t = (e = _regeneratorRuntime.mark(function e(t, n, r) {
      var o, i;
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return o = t.get(Me.a), e.next = 3, o.updateConfiguration(Ye({
                accountSid: n
              }, r));

            case 3:
              return i = e.sent, e.abrupt("return", i);

            case 5:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }), function () {
      var t = this,
          n = arguments;
      return new Promise(function (r, o) {
        var i = e.apply(t, n);

        function a(e) {
          Ze(i, r, o, a, u, "next", e);
        }

        function u(e) {
          Ze(i, r, o, a, u, "throw", e);
        }

        a(void 0);
      });
    });
    return function (e, n, r) {
      return t.apply(this, arguments);
    };
  }(),
      tt = n(78),
      nt = new r.ContainerModule(function (e) {
    e(u.b).to(Je).inSingletonScope(), e(u.c).to(tt.a).inSingletonScope(), e(u.a).toProvider(function (e) {
      return function () {
        return Ae(e.container);
      };
    }), e(We.c).toDynamicValue(function (e) {
      return function (t, n) {
        return et(e.container, t, n);
      };
    }), e(u.d).toDynamicValue(Le), e(u.e).toProvider(function (e) {
      return function (t) {
        return Object(Qe.a)(e.container, t);
      };
    });
  }),
      rt = n(27),
      ot = n(36),
      it = n(107);

  var at,
      ut,
      ct = new r.ContainerModule(function (e) {
    e(rt.a).toConstructor(ot.a), e(rt.b).toConstantValue("flex"), e(rt.d).to(it.a).inSingletonScope(), e(rt.c).toFactory(function (e) {
      return function (t, n, r) {
        return function (e, t, n, r) {
          return new (e.get(rt.a))(t, n, r);
        }(e.container, t, n, r);
      };
    });
  }),
      st = n(109),
      lt = n(64),
      ft = (n(56), n(57), new r.ContainerModule(function (e) {
    e(lt.a).toDynamicValue(function (e) {
      return {
        requiredRole: Object(st.a)(e.container),
        hasRole: (t = e.container, function (e) {
          return t.get(C.c).roles.includes(e);
        })
      };
      var t;
    });
  })),
      dt = (n(54), n(59)),
      pt = n(20),
      vt = n(79),
      bt = n(80);

  function ht(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  function yt(e, t) {
    var n = t.get(e);
    if (!n) throw new TypeError("attempted to get private field on non-instance");
    return n.get ? n.get.call(e) : n.value;
  }

  var mt = Object(r.injectable)()((ut = new WeakMap(), at = function e(t) {
    var n = this;
    !function (e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }(this, e), ut.set(this, {
      writable: !0,
      value: void 0
    }), ht(this, "trace", function () {
      var e;
      (e = yt(n, ut)).trace.apply(e, arguments);
    }), ht(this, "debug", function () {
      var e;
      (e = yt(n, ut)).debug.apply(e, arguments);
    }), ht(this, "log", function () {
      var e;
      (e = yt(n, ut)).debug.apply(e, arguments);
    }), ht(this, "info", function () {
      var e;
      (e = yt(n, ut)).info.apply(e, arguments);
    }), ht(this, "warn", function () {
      var e;
      (e = yt(n, ut)).warn.apply(e, arguments);
    }), ht(this, "error", function () {
      var e;
      (e = yt(n, ut)).error.apply(e, arguments);
    }), ht(this, "setLevel", function (e) {
      yt(n, ut).setLevel(e);
    }), ht(this, "getLevel", function () {
      return yt(n, ut).getLevel();
    }), function (e, t, n) {
      var r = t.get(e);
      if (!r) throw new TypeError("attempted to set private field on non-instance");
      if (r.set) r.set.call(e, n);else {
        if (!r.writable) throw new TypeError("attempted to set read only private field");
        r.value = n;
      }
    }(this, ut, t);
  })) || at,
      wt = (n(39), n(40), function (e) {
    return e < 10 ? "0".concat(e) : "".concat(e);
  }),
      gt = function gt(e) {
    var t = e.getFullYear(),
        n = wt(e.getMonth() + 1),
        r = wt(e.getDate()),
        o = wt(e.getHours()),
        i = wt(e.getMinutes()),
        a = wt(e.getSeconds()),
        u = wt(e.getMilliseconds());
    return "".concat(t, "-").concat(n, "-").concat(r, " ").concat(o, ":").concat(i, ":").concat(a, ".").concat(u);
  },
      jt = [function (e) {
    return function (t, n, r) {
      return function (o) {
        for (var i = o instanceof I.a, a = arguments.length, u = new Array(a > 1 ? a - 1 : 0), c = 1; c < a; c++) {
          u[c - 1] = arguments[c];
        }

        i || u.unshift(o);
        var s = i ? o : new I.a(r, t),
            l = e(t, n, r);
        return l.apply(void 0, [s].concat(u));
      };
    };
  }, function (e) {
    return function (t, n, r) {
      return function (o) {
        for (var i = e(t, n, r), a = arguments.length, u = new Array(a > 1 ? a - 1 : 0), c = 1; c < a; c++) {
          u[c - 1] = arguments[c];
        }

        return i.apply(void 0, [o].concat(u));
      };
    };
  }, function (e) {
    return function (t, n, r) {
      return function (o) {
        for (var i = arguments.length, a = new Array(i > 1 ? i - 1 : 0), u = 1; u < i; u++) {
          a[u - 1] = arguments[u];
        }

        o.data || (o.data = a);
        var c = e(t, n, r);
        return c.apply(void 0, [o].concat(a));
      };
    };
  }, function (e) {
    return function (t, n, r) {
      return function (o) {
        for (var i = gt(o.timestamp), a = o.severity.toUpperCase(), u = "[".concat(i, "] Flex SDK → ").concat(r, " (").concat(a, "): "), c = e(t, n, r), s = arguments.length, l = new Array(s > 1 ? s - 1 : 0), f = 1; f < s; f++) {
          l[f - 1] = arguments[f];
        }

        return c.apply(void 0, [u].concat(l));
      };
    };
  }].reverse(),
      kt = function kt(e) {
    return jt.forEach(function (t) {
      var n = e.methodFactory;
      e.methodFactory = t(n);
    }), e.setLevel(e.getLevel()), e;
  },
      Ot = new r.ContainerModule(function (e) {
    e(pt.e).toConstantValue(dt.getLogger), e(pt.b).toFactory(function (e) {
      return Object(vt.a)(e.container);
    }), e(pt.f).toConstructor(mt), e(pt.a).toConstantValue([kt]), e(pt.d).toConstantValue(Object(bt.a)()), e(pt.c).toConstantValue(new Map());
  }),
      St = n(16),
      xt = n(32),
      Et = n(110);

  function Tt(e, t, n, r, o, i, a) {
    try {
      var u = e[i](a),
          c = u.value;
    } catch (e) {
      return void n(e);
    }

    u.done ? t(c) : Promise.resolve(c).then(r, o);
  }

  function Pt(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  function Ct(e, t) {
    var n = t.get(e);
    if (!n) throw new TypeError("attempted to get private field on non-instance");
    return n.get ? n.get.call(e) : n.value;
  }

  function Rt(e, t, n) {
    var r = t.get(e);
    if (!r) throw new TypeError("attempted to set private field on non-instance");
    if (r.set) r.set.call(e, n);else {
      if (!r.writable) throw new TypeError("attempted to set read only private field");
      r.value = n;
    }
    return n;
  }

  var Mt,
      It = new WeakMap(),
      At = new WeakMap(),
      Wt = function () {
    function e(t, n) {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e), It.set(this, {
        writable: !0,
        value: void 0
      }), At.set(this, {
        writable: !0,
        value: void 0
      }), Rt(this, It, t), Rt(this, At, n);
    }

    var t, n, r, o, i;
    return t = e, (n = [{
      key: "sid",
      get: function get() {
        return Ct(this, It).sid;
      }
    }, {
      key: "dateUpdated",
      get: function get() {
        return Ct(this, It).dateUpdated;
      }
    }, {
      key: "uniqueName",
      get: function get() {
        return Ct(this, It).uniqueName;
      }
    }, {
      key: "get",
      value: (o = _regeneratorRuntime.mark(function e(t) {
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", Ct(this, At).call(this, Ct(this, It), t));

              case 1:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      }), i = function i() {
        var e = this,
            t = arguments;
        return new Promise(function (n, r) {
          var i = o.apply(e, t);

          function a(e) {
            Tt(i, n, r, a, u, "next", e);
          }

          function u(e) {
            Tt(i, n, r, a, u, "throw", e);
          }

          a(void 0);
        });
      }, function (e) {
        return i.apply(this, arguments);
      })
    }, {
      key: "on",
      value: function value(e, t) {
        Ct(this, It).on(e, t);
      }
    }, {
      key: "removeListener",
      value: function value(e, t) {
        Ct(this, It).removeListener(e, t);
      }
    }]) && Pt(t.prototype, n), r && Pt(t, r), e;
  }(),
      Dt = (n(131), n(74), n(99), n(125), n(47));

  function Ft(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function qt(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? Ft(Object(n), !0).forEach(function (t) {
        Ut(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ft(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }

    return e;
  }

  function Nt(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  function Ut(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  !function (e) {
    e.ItemUpdated = "itemUpdated";
  }(Mt || (Mt = {}));

  var _t,
      Lt,
      Vt,
      Kt = {
    mapKeysToCamelCase: !0,
    dateFields: ["timestampUpdated"]
  },
      zt = function () {
    function e(t, n) {
      var r = this;
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e), Ut(this, "subscribableSubItems", new Map()), Ut(this, "subscribers", []), Ut(this, "subscribe", function (e) {
        r.subscribers.push(e), 1 === r.subscribers.length && r.syncMap.on(Mt.ItemUpdated, r.itemUpdatedHandler);
      }), Ut(this, "unsubscribe", function (e) {
        var t = r.subscribers.indexOf(e);
        t < 0 || (r.subscribers.splice(t, 1), 0 === r.subscribers.length && r.syncMap.removeListener(Mt.ItemUpdated, r.itemUpdatedHandler));
      }), Ut(this, "itemUpdatedHandler", function (e) {
        var t = e.item;
        t.key === r.key && (r.updateValue(t.value), r.subscribers.forEach(function (e) {
          return e();
        }));
      }), this.syncMap = t, this.itemKey = n.key, this._value = n.value;
    }

    var t, n, r;
    return t = e, (n = [{
      key: "key",
      get: function get() {
        return this.itemKey;
      }
    }, {
      key: "value",
      get: function get() {
        return this._value;
      }
    }, {
      key: "getSubscribable",
      value: function value() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};

        if (!this.subscribable) {
          var t = qt(qt({}, Kt), e);
          this.subscribable = {
            options: t,
            value: Object(Dt.a)(this._value, t, this.subscribe, this.unsubscribe)
          };
        }

        return this.subscribable.value;
      }
    }, {
      key: "getSubscribableForSubKey",
      value: function value(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = this.subscribableSubItems.get(e);

        if (!n) {
          var r = this.getSubValue(e),
              o = qt(qt({}, Kt), t),
              i = Object(Dt.a)(r, o, this.subscribe, this.unsubscribe);
          n = {
            options: o,
            value: i
          }, this.subscribableSubItems.set(e, n);
        }

        return n.value;
      }
    }, {
      key: "updateValue",
      value: function value(e) {
        var t = this;

        if (this._value = e, this.subscribable) {
          var n = Object(Dt.a)(e, this.subscribable.options, this.subscribe, this.unsubscribe);
          this.deleteRemovedSubKeys(this.subscribable.value, n), Object.assign(this.subscribable.value, qt({}, n));
        }

        this.subscribableSubItems.forEach(function (e, n) {
          var r = t.getSubValue(n),
              o = Object(Dt.a)(r, e.options, t.subscribe, t.unsubscribe);
          t.deleteRemovedSubKeys(e.value, o), Object.assign(e.value, qt({}, o));
        });
      }
    }, {
      key: "deleteRemovedSubKeys",
      value: function value(e, t) {
        var n = e;
        Object.keys(n).filter(function (e) {
          return !Object.prototype.hasOwnProperty.call(t, e);
        }).forEach(function (e) {
          delete n[e];
        });
      }
    }, {
      key: "isIndexObject",
      value: function value(e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      }
    }, {
      key: "getSubValue",
      value: function value(e) {
        if (this.isIndexObject(this.value, e)) return this.value[e];
        throw new M.d("Key ".concat(e, " does not exist in item ").concat(this.itemKey));
      }
    }]) && Nt(t.prototype, n), r && Nt(t, r), e;
  }(),
      Bt = n(111),
      Ht = n(112),
      Gt = n(113),
      Jt = new r.ContainerModule(function (e) {
    e(St.a).toConstructor(xt.a), e(St.h).to(Et.a), e(St.c).toConstructor(Wt), e(St.b).toConstructor(zt), e(St.f).toProvider(function (e) {
      return function (t, n, r) {
        return Object(Bt.a)(e.container, t, n, r);
      };
    }), e(St.e).toProvider(function (e) {
      return function (t, n) {
        return Object(Ht.a)(e.container, t, n);
      };
    }), e(St.g).toProvider(function (e) {
      return function (t) {
        return Object(Gt.a)(e.container, t);
      };
    }), e(St.d).toConstantValue(new Map());
  }),
      Qt = n(17);

  n(55);

  function $t(e, t, n, r, o, i, a) {
    try {
      var u = e[i](a),
          c = u.value;
    } catch (e) {
      return void n(e);
    }

    u.done ? t(c) : Promise.resolve(c).then(r, o);
  }

  function Yt(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  function Xt(e, t) {
    var n = t.get(e);
    if (!n) throw new TypeError("attempted to get private field on non-instance");
    return n.get ? n.get.call(e) : n.value;
  }

  function Zt(e, t, n) {
    var r = t.get(e);
    if (!r) throw new TypeError("attempted to set private field on non-instance");
    if (r.set) r.set.call(e, n);else {
      if (!r.writable) throw new TypeError("attempted to set read only private field");
      r.value = n;
    }
    return n;
  }

  var en,
      tn,
      nn,
      rn,
      on = Object(r.injectable)()((Lt = new WeakMap(), Vt = new WeakMap(), _t = function () {
    function e(t, n) {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e), Lt.set(this, {
        writable: !0,
        value: void 0
      }), Vt.set(this, {
        writable: !0,
        value: void 0
      }), Zt(this, Lt, t), Zt(this, Vt, n(I.c.TelemetryClient));
    }

    var t, n, o, i, a;
    return e = Object(r.inject)(I.d)(e, void 0, 1) || e, e = Object(r.inject)(Qt.c)(e, void 0, 0) || e, t = e, (n = [{
      key: "createEventGroup",
      value: function value(e) {
        return Xt(this, Vt).debug("creating event group with name: ", e), Xt(this, Lt).call(this, this, e);
      }
    }, {
      key: "setSessionData",
      value: (i = _regeneratorRuntime.mark(function e(t) {
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                this.sessionData = t;

              case 1:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      }), a = function a() {
        var e = this,
            t = arguments;
        return new Promise(function (n, r) {
          var o = i.apply(e, t);

          function a(e) {
            $t(o, n, r, a, u, "next", e);
          }

          function u(e) {
            $t(o, n, r, a, u, "throw", e);
          }

          a(void 0);
        });
      }, function (e) {
        return a.apply(this, arguments);
      })
    }]) && Yt(t.prototype, n), o && Yt(t, o), e;
  }())) || _t;

  function an(e, t, n, r, o, i, a) {
    try {
      var u = e[i](a),
          c = u.value;
    } catch (e) {
      return void n(e);
    }

    u.done ? t(c) : Promise.resolve(c).then(r, o);
  }

  function un(e) {
    return function () {
      var t = this,
          n = arguments;
      return new Promise(function (r, o) {
        var i = e.apply(t, n);

        function a(e) {
          an(i, r, o, a, u, "next", e);
        }

        function u(e) {
          an(i, r, o, a, u, "throw", e);
        }

        a(void 0);
      });
    };
  }

  function cn(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  function sn(e, t) {
    var n = t.get(e);
    if (!n) throw new TypeError("attempted to get private field on non-instance");
    return n.get ? n.get.call(e) : n.value;
  }

  function ln(e, t, n) {
    var r = t.get(e);
    if (!r) throw new TypeError("attempted to set private field on non-instance");
    if (r.set) r.set.call(e, n);else {
      if (!r.writable) throw new TypeError("attempted to set read only private field");
      r.value = n;
    }
    return n;
  }

  var fn = Object(r.injectable)()((tn = new WeakMap(), nn = new WeakMap(), rn = new WeakMap(), en = function () {
    function e(t, n, r) {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e), tn.set(this, {
        writable: !0,
        value: void 0
      }), nn.set(this, {
        writable: !0,
        value: void 0
      }), rn.set(this, {
        writable: !0,
        value: void 0
      }), ln(this, tn, t), ln(this, nn, n), ln(this, rn, r);
    }

    var t, n, o, i, a;
    return e = Object(r.inject)(R.b)(e, void 0, 2) || e, e = Object(r.inject)(Qt.e)(e, void 0, 1) || e, e = Object(r.inject)(Qt.f)(e, void 0, 0) || e, t = e, (n = [{
      key: "addEvents",
      value: (a = un(_regeneratorRuntime.mark(function e() {
        var t,
            n,
            r,
            o,
            i = arguments;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                for (n = i.length, r = new Array(n), o = 0; o < n; o++) {
                  r[o] = i[o];
                }

                return e.abrupt("return", (t = sn(this, tn)).processEvents.apply(t, [this.telemetryClient.name, this.name, this.telemetryClient.sessionData].concat(r)));

              case 2:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return a.apply(this, arguments);
      })
    }, {
      key: "addErrorEvent",
      value: (i = un(_regeneratorRuntime.mark(function e(t) {
        var n;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (n = sn(this, rn).isConnected(), sn(this, nn).reportErrors && n) {
                  e.next = 4;
                  break;
                }

                return e.abrupt("return", {
                  eventsSucceeded: 0,
                  eventsFailed: 0,
                  eventsNotProcessed: 1
                });

              case 4:
                return e.abrupt("return", sn(this, tn).processEvents("flex-ui-sdk-error-v1", this.name, this.telemetryClient.sessionData, t));

              case 5:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (e) {
        return i.apply(this, arguments);
      })
    }]) && cn(t.prototype, n), o && cn(t, o), e;
  }())) || en,
      dn = n(114),
      pn = n(81),
      vn = new r.ContainerModule(function (e) {
    e(Qt.a).toFactory(function (e) {
      return function (t) {
        return Object(ee.a)(e.container, t);
      };
    }), e(Qt.b).to(on), e(Qt.c).toFactory(function (e) {
      return function (t, n) {
        return function (e, t, n) {
          var r = e.get(Qt.d);
          return r.name = n, r.telemetryClient = t, r;
        }(e.container, t, n);
      };
    }), e(Qt.d).to(fn), e(Qt.f).to(dn.a).inSingletonScope(), e(Qt.e).toConstantValue(Object(pn.a)());
  }),
      bn = n(25),
      hn = n(116),
      yn = n(117),
      mn = n(118);
  var wn,
      gn = n(119),
      jn = new r.ContainerModule(function (e) {
    e(bn.d).to(gn.a).inSingletonScope(), e(bn.a).toConstructor(yn.a), e(bn.c).toProvider(function (e) {
      return function (t) {
        return Object(hn.a)(e.container, t);
      };
    }), e(bn.b).toConstructor(mn.a), e(bn.e).toFactory(function (e) {
      return function (t) {
        return function (e, t) {
          return new (e.get(bn.b))(t, e.get(Me.c), e.get(M.h), e.get(M.g));
        }(e.container, t);
      };
    });
  }),
      kn = n(37),
      On = new r.ContainerModule(function (e) {
    e(kn.a).toDynamicValue(function (e) {
      return Object(ee.a)(e.container, "sdk-v1");
    }).inSingletonScope(), e(kn.b).toDynamicValue(function (e) {
      return e.container.get(kn.a).createEventGroup();
    }).inSingletonScope();
  }),
      Sn = n(82),
      xn = n(87),
      En = n(83),
      Tn = n(84),
      Pn = n(85),
      Cn = n(86);

  function Rn() {
    var e = new r.Container();
    return e.load(T), e.load(nt), e.load(X), e.load(pe), e.load(Te), e.load(Re), e.load(ct), e.load(ft), e.load(Ot), e.load(Jt), e.load(vn), e.load(On), e.load(jn), function (e) {
      e.bind(Me.d).to(Tn.a).inSingletonScope(), e.bind(Me.f).to(Pn.a).inSingletonScope(), e.bind(Me.b).to(Cn.a).inSingletonScope(), Sn.a.with(e), xn.a.with(e), En.a.with(e);
    }(e), e;
  }

  function Mn() {
    return wn || (wn = Rn()), wn;
  }
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return u;
  });
  n(39), n(40);
  var r = n(35),
      o = n(67);

  function i(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function a(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  function u(e, t, n, u) {
    return function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? i(Object(n), !0).forEach(function (t) {
          a(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : i(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }

      return e;
    }({
      subscribe: n,
      unsubscribe: u
    }, function (e, t) {
      var n = t.mapKeysToCamelCase ? Object(r.b)(e) : e;
      return t.dateFields && t.dateFields.forEach(function (e) {
        if (Object(o.a)(n, e)) {
          var t = n[e];
          n[e] = t ? new Date(t) : void 0;
        }
      }), n;
    }(e, t));
  }
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return o.a;
  }), n.d(t, "b", function () {
    return r;
  }), n.d(t, "c", function () {
    return i.d;
  });
  var r,
      o = n(62);
  !function (e) {
    e.Today = "tasks_today", e.ThirtyMinutes = "tasks_thirty_minutes", e.Yesterday = "tasks_yesterday";
  }(r || (r = {}));
  var i = n(25);
}, function (e, t) {
  e.exports = require("events");
}, function (e, t, n) {
  "use strict";

  var r;
  n.d(t, "a", function () {
    return r;
  }), function (e) {
    e.Destroyed = "destroyed";
  }(r || (r = {}));
}, function (e, t, n) {
  var r, o;

  function i(e) {
    return (i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  n(23), n(24), n(71), n(74), n(5), n(98), n(55), n(3), n(42), n(6), n(7), function (a, u) {
    "use strict";

    void 0 === (o = "function" == typeof (r = function r() {
      var e = function e() {},
          t = "undefined" !== ("undefined" == typeof window ? "undefined" : i(window)) && "undefined" !== i(window.navigator) && /Trident\/|MSIE /.test(window.navigator.userAgent),
          n = ["trace", "debug", "info", "warn", "error"];

      function r(e, t) {
        var n = e[t];
        if ("function" == typeof n.bind) return n.bind(e);

        try {
          return Function.prototype.bind.call(n, e);
        } catch (t) {
          return function () {
            return Function.prototype.apply.apply(n, [e, arguments]);
          };
        }
      }

      function o() {
        console.log && (console.log.apply ? console.log.apply(console, arguments) : Function.prototype.apply.apply(console.log, [console, arguments])), console.trace && console.trace();
      }

      function a(n) {
        return "debug" === n && (n = "log"), "undefined" !== ("undefined" == typeof console ? "undefined" : i(console)) && ("trace" === n && t ? o : void 0 !== console[n] ? r(console, n) : void 0 !== console.log ? r(console, "log") : e);
      }

      function u(t, r) {
        for (var o = 0; o < n.length; o++) {
          var i = n[o];
          this[i] = o < t ? e : this.methodFactory(i, t, r);
        }

        this.log = this.debug;
      }

      function c(e, t, n) {
        return function () {
          "undefined" !== ("undefined" == typeof console ? "undefined" : i(console)) && (u.call(this, t, n), this[e].apply(this, arguments));
        };
      }

      function s(e, t, n) {
        return a(e) || c.apply(this, arguments);
      }

      function l(e, t, r) {
        var o,
            a = this,
            c = "loglevel";

        function l() {
          var e;

          if ("undefined" !== ("undefined" == typeof window ? "undefined" : i(window)) && c) {
            try {
              e = window.localStorage[c];
            } catch (e) {}

            if ("undefined" === i(e)) try {
              var t = window.document.cookie,
                  n = t.indexOf(encodeURIComponent(c) + "=");
              -1 !== n && (e = /^([^;]+)/.exec(t.slice(n))[1]);
            } catch (e) {}
            return void 0 === a.levels[e] && (e = void 0), e;
          }
        }

        "string" == typeof e ? c += ":" + e : "symbol" === i(e) && (c = void 0), a.name = e, a.levels = {
          TRACE: 0,
          DEBUG: 1,
          INFO: 2,
          WARN: 3,
          ERROR: 4,
          SILENT: 5
        }, a.methodFactory = r || s, a.getLevel = function () {
          return o;
        }, a.setLevel = function (t, r) {
          if ("string" == typeof t && void 0 !== a.levels[t.toUpperCase()] && (t = a.levels[t.toUpperCase()]), !("number" == typeof t && t >= 0 && t <= a.levels.SILENT)) throw "log.setLevel() called with invalid level: " + t;
          if (o = t, !1 !== r && function (e) {
            var t = (n[e] || "silent").toUpperCase();

            if ("undefined" !== ("undefined" == typeof window ? "undefined" : i(window)) && c) {
              try {
                return void (window.localStorage[c] = t);
              } catch (e) {}

              try {
                window.document.cookie = encodeURIComponent(c) + "=" + t + ";";
              } catch (e) {}
            }
          }(t), u.call(a, t, e), "undefined" === ("undefined" == typeof console ? "undefined" : i(console)) && t < a.levels.SILENT) return "No console available for logging";
        }, a.setDefaultLevel = function (e) {
          l() || a.setLevel(e, !1);
        }, a.enableAll = function (e) {
          a.setLevel(a.levels.TRACE, e);
        }, a.disableAll = function (e) {
          a.setLevel(a.levels.SILENT, e);
        };
        var f = l();
        null == f && (f = null == t ? "WARN" : t), a.setLevel(f, !1);
      }

      var f = new l(),
          d = {};

      f.getLogger = function (e) {
        if ("symbol" !== i(e) && "string" != typeof e || "" === e) throw new TypeError("You must supply a name when creating a logger.");
        var t = d[e];
        return t || (t = d[e] = new l(e, f.getLevel(), f.methodFactory)), t;
      };

      var p = "undefined" !== ("undefined" == typeof window ? "undefined" : i(window)) ? window.log : void 0;
      return f.noConflict = function () {
        return "undefined" !== ("undefined" == typeof window ? "undefined" : i(window)) && window.log === f && (window.log = p), f;
      }, f.getLoggers = function () {
        return d;
      }, f.default = f, f;
    }) ? r.call(t, n, t, e) : r) || (e.exports = o);
  }();
}, function (e, t, n) {
  "use strict";

  n.d(t, "d", function () {
    return o.g;
  }), n.d(t, "a", function () {
    return i.a;
  }), n.d(t, "b", function () {
    return a.a;
  }), n.d(t, "c", function () {
    return r;
  });
  var r,
      o = n(16),
      i = n(70),
      a = n(50);
  !function (e) {
    e.Flex = "flex", e.FlexInsights = "flex_insights";
  }(r || (r = {}));
}, function (e, t, n) {
  "use strict";

  function r(e, t, n) {
    n.enumerable = !0;
  }

  n.d(t, "a", function () {
    return r;
  });
}, function (e, t) {
  e.exports = require("core-js/modules/es.map.js");
}, function (e, t) {
  e.exports = require("core-js/modules/es.function.name.js");
}, function (e, t) {
  e.exports = require("core-js/modules/es.array.includes.js");
}, function (e, t) {
  e.exports = require("core-js/modules/es.string.includes.js");
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return r;
  });
  n(23), n(24), n(3);
  var r = Symbol.for("eventEmitter");
}, function (e, t) {
  e.exports = require("loglevel");
}, function (e, t) {
  e.exports = require("core-js/modules/es.string.replace.js");
}, function (e, t, n) {
  "use strict";

  var r;
  n.d(t, "a", function () {
    return r;
  }), function (e) {
    e.Fatal = "fatal", e.Error = "error", e.Warning = "warning", e.Info = "info";
  }(r || (r = {}));
}, function (e, t, n) {
  "use strict";

  var r;
  n.d(t, "a", function () {
    return r;
  }), function (e) {
    e.Metadata = "metadata";
  }(r || (r = {}));
}, function (e, t) {
  e.exports = require("twilio-sync");
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return r;
  });
  n(23), n(24), n(3);
  var r = Symbol.for("Rbac");
}, function (e) {
  e.exports = JSON.parse('{"a":"0.6.0"}');
}, function (e, t) {
  e.exports = require("lodash/cloneDeep");
}, function (e, t, n) {
  "use strict";

  function r(e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }

  n.d(t, "a", function () {
    return r;
  });
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return a;
  });
  n(39), n(132), n(133), n(42), n(96), n(40);
  var r = n(67);

  function o(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
      var n = [],
          r = !0,
          o = !1,
          i = void 0;

      try {
        for (var a, u = e[Symbol.iterator](); !(r = (a = u.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0) {
          ;
        }
      } catch (e) {
        o = !0, i = e;
      } finally {
        try {
          r || null == u.return || u.return();
        } finally {
          if (o) throw i;
        }
      }

      return n;
    }(e, t) || function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return i(e, t);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === n && e.constructor && (n = e.constructor.name);
      if ("Map" === n || "Set" === n) return Array.from(e);
      if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return i(e, t);
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }

  function i(e, t) {
    (null == t || t > e.length) && (t = e.length);

    for (var n = 0, r = new Array(t); n < t; n++) {
      r[n] = e[n];
    }

    return r;
  }

  function a(e) {
    var t = /^\d{4}-\d{1,2}-\d{1,2}/,
        n = new RegExp("date", "i"),
        i = {};
    return Object.entries(e).forEach(function (a) {
      var u = o(a, 2),
          c = u[0],
          s = u[1];
      Object(r.a)(e, c) && n.test(c) && t.test(s) ? i[c] = new Date(s) : i[c] = s;
    }), i;
  }
}, function (e, t, n) {
  "use strict";

  var r;
  n.d(t, "a", function () {
    return r;
  }), function (e) {
    e.TokenExpired = "tokenExpired", e.TokenAboutToExpire = "tokenAboutToExpire", e.StateChanged = "stateChanged", e.ConnectionError = "connectionError", e.Connected = "connected", e.Disconnected = "disconnected", e.TokenUpdated = "tokenUpdated";
  }(r || (r = {}));
}, function (e, t, n) {
  "use strict";

  var r;
  n.d(t, "a", function () {
    return r;
  }), function (e) {
    e.OpenExisting = "open_existing", e.OpenOrCreate = "open_or_create", e.CreateNew = "create_new";
  }(r || (r = {}));
}, function (e, t) {
  e.exports = require("core-js/modules/es.symbol.iterator.js");
}, function (e, t) {
  e.exports = require("core-js/modules/es.array.map.js");
}, function (e, t) {
  e.exports = require("core-js/modules/es.object.keys.js");
}, function (e, t) {
  e.exports = require("core-js/modules/es.array.index-of.js");
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return a;
  });
  var r = n(66),
      o = n.n(r),
      i = {
    autoUpdateToken: !0
  };

  function a() {
    return o()(i);
  }
}, function (e, t, n) {
  "use strict";

  (function (e, r) {
    n.d(t, "a", function () {
      return y;
    });
    n(3), n(13), n(8);
    var o = n(63),
        i = n(14),
        a = n(18),
        u = n(102),
        c = n(19),
        s = n(29),
        l = n(4),
        f = n(1),
        d = n(2);

    function p(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    function v(e, t, n, r, o, i, a) {
      try {
        var u = e[i](a),
            c = u.value;
      } catch (e) {
        return void n(e);
      }

      u.done ? t(c) : Promise.resolve(c).then(r, o);
    }

    function b(e) {
      return function () {
        var t = this,
            n = arguments;
        return new Promise(function (r, o) {
          var i = e.apply(t, n);

          function a(e) {
            v(i, r, o, a, u, "next", e);
          }

          function u(e) {
            v(i, r, o, a, u, "throw", e);
          }

          a(void 0);
        });
      };
    }

    var h = function () {
      var e = b(_regeneratorRuntime.mark(function e(t, n, r) {
        var o;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.prev = 0, o = n.createEventGroup(s.b.Default), e.next = 4, o.addEvents({
                  eventName: s.c.ClientInitialized,
                  eventSource: s.d.Client,
                  durationMs: r
                });

              case 4:
                e.next = 9;
                break;

              case 6:
                e.prev = 6, e.t0 = e.catch(0), t.error("Failed to send client init event", e.t0);

              case 9:
              case "end":
                return e.stop();
            }
          }
        }, e, null, [[0, 6]]);
      }));
      return function (t, n, r) {
        return e.apply(this, arguments);
      };
    }();

    function y(e, t, n) {
      return m.apply(this, arguments);
    }

    function m() {
      return (m = b(_regeneratorRuntime.mark(function t(n, v, b) {
        var y, m, w, g, j, k, O, S, x, E, T, P, C;
        return _regeneratorRuntime.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return y = Date.now(), Object(c.c)(v, "token"), m = n.get(i.b), w = n.get(l.d), g = w(l.b.Client), j = n.get(f.j), k = n.get(f.h), Object(u.a)(m, b), O = n.get(a.c), t.prev = 9, t.next = 12, O.init(v);

              case 12:
                t.next = 18;
                break;

              case 14:
                t.prev = 14, t.t0 = t.catch(9), S = {
                  module: Object(d.b)(e),
                  severity: f.b.Error,
                  source: Object(d.a)(r)
                }, 2002 === t.t0.code || 20003 === t.t0.code ? (S.source = "Twilsock", j(f.a.Forbidden, S, "Insufficient permissions", t.t0.source)) : k(t.t0, S);

              case 18:
                return t.prev = 18, E = {
                  dependencies: (x = {}, p(x, s.a.TwilioSync, o.SyncClient.version), p(x, s.a.Twilsock, "default"), x)
                }, T = n.get(s.e), t.next = 23, T.setSessionData(E);

              case 23:
                return P = Date.now() - y, t.next = 26, h(g, T, P);

              case 26:
                t.next = 31;
                break;

              case 28:
                t.prev = 28, t.t1 = t.catch(18), g.error("Failed to set session data for telemetry", t.t1);

              case 31:
                return C = n.get(i.d), t.abrupt("return", C);

              case 33:
              case "end":
                return t.stop();
            }
          }
        }, t, null, [[9, 14], [18, 28]]);
      }))).apply(this, arguments);
    }
  }).call(this, "/", "/index.js");
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return y;
  });
  n(5), n(3), n(6), n(11), n(7);
  var r,
      o,
      i,
      a,
      u,
      c,
      s,
      l = n(0),
      f = n(18),
      d = n(4),
      p = n(31);

  function v(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  function b(e, t) {
    var n = t.get(e);
    if (!n) throw new TypeError("attempted to get private field on non-instance");
    return n.get ? n.get.call(e) : n.value;
  }

  function h(e, t, n) {
    var r = t.get(e);
    if (!r) throw new TypeError("attempted to set private field on non-instance");
    if (r.set) r.set.call(e, n);else {
      if (!r.writable) throw new TypeError("attempted to set read only private field");
      r.value = n;
    }
    return n;
  }

  var y = Object(l.injectable)()((o = new WeakMap(), i = new WeakMap(), a = new WeakMap(), u = new WeakMap(), c = new WeakMap(), s = new WeakMap(), r = function () {
    function e(t, n, r) {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e), o.set(this, {
        writable: !0,
        value: void 0
      }), i.set(this, {
        writable: !0,
        value: void 0
      }), a.set(this, {
        writable: !0,
        value: void 0
      }), u.set(this, {
        writable: !0,
        value: void 0
      }), c.set(this, {
        writable: !0,
        value: void 0
      }), s.set(this, {
        writable: !0,
        value: void 0
      }), h(this, o, t), h(this, i, n), h(this, a, r);
    }

    var t, n, r;
    return e = Object(l.inject)(p.e)(e, void 0, 2) || e, e = Object(l.inject)(d.e)(e, void 0, 1) || e, e = Object(l.inject)(f.b)(e, void 0, 0) || e, t = e, (n = [{
      key: "session",
      get: function get() {
        return b(this, o);
      }
    }, {
      key: "logger",
      get: function get() {
        return b(this, i);
      }
    }, {
      key: "telemetry",
      get: function get() {
        return b(this, a);
      }
    }, {
      key: "region",
      get: function get() {
        return b(this, u);
      },
      set: function set(e) {
        h(this, u, e);
      }
    }, {
      key: "appName",
      get: function get() {
        return b(this, c);
      },
      set: function set(e) {
        h(this, c, e);
      }
    }, {
      key: "appVersion",
      get: function get() {
        return b(this, s);
      },
      set: function set(e) {
        h(this, s, e);
      }
    }]) && v(t.prototype, n), r && v(t, r), e;
  }())) || r;
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return s;
  });
  n(5), n(3), n(6), n(11), n(7);
  var r,
      o,
      i = n(0),
      a = n(1);

  function u(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  function c(e, t) {
    var n = t.get(e);
    if (!n) throw new TypeError("attempted to get private field on non-instance");
    return n.get ? n.get.call(e) : n.value;
  }

  var s = Object(i.injectable)()((o = new WeakMap(), r = function () {
    function e() {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e), o.set(this, {
        writable: !0,
        value: void 0
      });
    }

    var t, n, r;
    return t = e, (n = [{
      key: "get",
      value: function value() {
        if (!c(this, o)) throw new a.d("Config data hasn't been fetched");
        return c(this, o);
      }
    }, {
      key: "set",
      value: function value(e) {
        !function (e, t, n) {
          var r = t.get(e);
          if (!r) throw new TypeError("attempted to set private field on non-instance");
          if (r.set) r.set.call(e, n);else {
            if (!r.writable) throw new TypeError("attempted to set read only private field");
            r.value = n;
          }
        }(this, o, e);
      }
    }]) && u(t.prototype, n), r && u(t, r), e;
  }())) || r;
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return f;
  });
  n(56), n(97), n(73), n(57);
  var r,
      o = n(51),
      i = n.n(o),
      a = n(20),
      u = n(19),
      c = n(44);

  function s(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  var l = (s(r = {}, c.b.TwilioChat, i.a), s(r, c.b.TwilioSync, i.a), s(r, c.b.Twilsock, i.a), r),
      f = function f(e) {
    return function (t) {
      Object(u.e)(t, "name");
      var n = e.get(a.c),
          r = n.get(t);
      if (r) return r;
      var o,
          i = e.get(a.d).level,
          c = e.get(a.e),
          s = e.get(a.a);
      return o = Object.keys(l).includes(t) ? function (e) {
        return l[e].getLogger(e);
      }(t) : c(t), o = s.reduce(function (e, t) {
        return t(e);
      }, o), (r = new (e.get(a.f))(o)).setLevel(i), n.set(t, r), r;
    };
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return a;
  });
  var r = n(66),
      o = n.n(r),
      i = {
    level: "ERROR"
  };

  function a() {
    return o()(i);
  }
}, function (e, t, n) {
  "use strict";

  function r() {
    return {
      reportErrors: !0
    };
  }

  n.d(t, "a", function () {
    return r;
  });
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return i;
  });
  var r = n(121);

  function o(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  var i = function () {
    function e() {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e);
    }

    var t, n, i;
    return t = e, i = [{
      key: "with",
      value: function value(e) {
        e.bind("TelemetryService").to(r.a).inSingletonScope();
      }
    }], (n = null) && o(t.prototype, n), i && o(t, i), e;
  }();
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return i;
  });
  var r = n(123);

  function o(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  var i = function () {
    function e() {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e);
    }

    var t, n, i;
    return t = e, i = [{
      key: "with",
      value: function value(e) {
        e.bind("ConfigurationService").to(r.a).inSingletonScope();
      }
    }], (n = null) && o(t.prototype, n), i && o(t, i), e;
  }();
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return p;
  });
  n(56), n(91), n(42), n(57), n(134), n(8);
  var r,
      o = n(0),
      i = n(4),
      a = n(52),
      u = n(1);

  function c(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
      var n = [],
          r = !0,
          o = !1,
          i = void 0;

      try {
        for (var a, u = e[Symbol.iterator](); !(r = (a = u.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0) {
          ;
        }
      } catch (e) {
        o = !0, i = e;
      } finally {
        try {
          r || null == u.return || u.return();
        } finally {
          if (o) throw i;
        }
      }

      return n;
    }(e, t) || function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return s(e, t);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === n && e.constructor && (n = e.constructor.name);
      if ("Map" === n || "Set" === n) return Array.from(e);
      if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return s(e, t);
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }

  function s(e, t) {
    (null == t || t > e.length) && (t = e.length);

    for (var n = 0, r = new Array(t); n < t; n++) {
      r[n] = e[n];
    }

    return r;
  }

  function l(e, t, n, r, o, i, a) {
    try {
      var u = e[i](a),
          c = u.value;
    } catch (e) {
      return void n(e);
    }

    u.done ? t(c) : Promise.resolve(c).then(r, o);
  }

  function f(e) {
    return function () {
      var t = this,
          n = arguments;
      return new Promise(function (r, o) {
        var i = e.apply(t, n);

        function a(e) {
          l(i, r, o, a, u, "next", e);
        }

        function u(e) {
          l(i, r, o, a, u, "throw", e);
        }

        a(void 0);
      });
    };
  }

  function d(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  var p = Object(o.injectable)()(r = function () {
    function e(t, n) {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e), this.logger = n(i.b.SyncAdapter), this.syncProvider = t;
    }

    var t, n, r, s, l;
    return e = Object(o.inject)(i.d)(e, void 0, 1) || e, e = Object(o.inject)(a.d)(e, void 0, 0) || e, t = e, (n = [{
      key: "getSyncObjectByPath",
      value: (l = f(_regeneratorRuntime.mark(function e(t) {
        var n, r, o, i, s, l, f;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (this.logger.trace("getSyncObjectByPath", t), n = t.split("/"), (r = c(n, 6))[0], o = r[1], i = r[2], s = r[3], r[4], l = r[5], f = o, Object.values(a.c).includes(f)) {
                  e.next = 5;
                  break;
                }

                throw new u.d("Unknown product id: ".concat(o));

              case 5:
                if ("Documents" !== i) {
                  e.next = 7;
                  break;
                }

                return e.abrupt("return", this.getDocument(f, s));

              case 7:
                if ("Maps" !== i) {
                  e.next = 11;
                  break;
                }

                if (!l) {
                  e.next = 10;
                  break;
                }

                return e.abrupt("return", this.getMapItem(f, s, l));

              case 10:
                return e.abrupt("return", this.getMap(f, s));

              case 11:
                if ("Lists" !== i) {
                  e.next = 13;
                  break;
                }

                return e.abrupt("return", this.getList(f, s));

              case 13:
                throw new u.d("Invalid Sync Object URL");

              case 14:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (e) {
        return l.apply(this, arguments);
      })
    }, {
      key: "getDocument",
      value: function value(e, t) {
        throw this.logger.trace("getDocument", e, t), new Error("Not implemented.");
      }
    }, {
      key: "getList",
      value: function value(e, t) {
        throw this.logger.trace("getList", e, t), new Error("Not implemented.");
      }
    }, {
      key: "getMap",
      value: function value(e, t) {
        throw this.logger.trace("getMap", e, t), new Error("Not implemented.");
      }
    }, {
      key: "getMapItem",
      value: (s = f(_regeneratorRuntime.mark(function e(t, n, r) {
        var o, i, a;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return this.logger.trace("getMapItem", t, n, r), e.next = 3, this.syncProvider(t);

              case 3:
                return o = e.sent, e.next = 6, o.getMapById(n);

              case 6:
                return i = e.sent, e.next = 9, i.get(r);

              case 9:
                return a = e.sent, e.abrupt("return", a);

              case 11:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (e, t, n) {
        return s.apply(this, arguments);
      })
    }]) && d(t.prototype, n), r && d(t, r), e;
  }()) || r;
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return l;
  });
  n(5), n(3), n(6), n(11), n(7), n(8);
  var r,
      o,
      i = n(0),
      a = n(10);

  function u(e, t, n, r, o, i, a) {
    try {
      var u = e[i](a),
          c = u.value;
    } catch (e) {
      return void n(e);
    }

    u.done ? t(c) : Promise.resolve(c).then(r, o);
  }

  function c(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  function s(e, t) {
    var n = t.get(e);
    if (!n) throw new TypeError("attempted to get private field on non-instance");
    return n.get ? n.get.call(e) : n.value;
  }

  var l = Object(i.injectable)()((o = new WeakMap(), r = function () {
    function e(t) {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e), o.set(this, {
        writable: !0,
        value: void 0
      }), function (e, t, n) {
        var r = t.get(e);
        if (!r) throw new TypeError("attempted to set private field on non-instance");
        if (r.set) r.set.call(e, n);else {
          if (!r.writable) throw new TypeError("attempted to set read only private field");
          r.value = n;
        }
      }(this, o, t);
    }

    var t, n, r, l, f;
    return e = Object(i.inject)(a.b)(e, void 0, 0) || e, t = e, (n = [{
      key: "post",
      value: (l = _regeneratorRuntime.mark(function e(t, n) {
        var r;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.next = 2, s(this, o).post(t, {}, n);

              case 2:
                return r = e.sent, e.abrupt("return", r);

              case 4:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      }), f = function f() {
        var e = this,
            t = arguments;
        return new Promise(function (n, r) {
          var o = l.apply(e, t);

          function i(e) {
            u(o, n, r, i, a, "next", e);
          }

          function a(e) {
            u(o, n, r, i, a, "throw", e);
          }

          i(void 0);
        });
      }, function (e, t) {
        return f.apply(this, arguments);
      })
    }]) && c(t.prototype, n), r && c(t, r), e;
  }())) || r;
}, function (e, t, n) {
  "use strict";

  (function (e) {
    n.d(t, "a", function () {
      return v;
    });
    n(5), n(3), n(13), n(42), n(6), n(60), n(135), n(11), n(7), n(8);
    var r,
        o,
        i = n(0),
        a = n(1),
        u = n(18),
        c = n(9),
        s = n(35),
        l = n(2);

    function f(e, t, n, r, o, i, a) {
      try {
        var u = e[i](a),
            c = u.value;
      } catch (e) {
        return void n(e);
      }

      u.done ? t(c) : Promise.resolve(c).then(r, o);
    }

    function d(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function p(e, t) {
      var n = t.get(e);
      if (!n) throw new TypeError("attempted to get private field on non-instance");
      return n.get ? n.get.call(e) : n.value;
    }

    var v = Object(i.injectable)()((o = new WeakMap(), r = function () {
      function t(e, n, r) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), o.set(this, {
          writable: !0,
          value: void 0
        }), this.session = e, this.envConfig = n, function (e, t, n) {
          var r = t.get(e);
          if (!r) throw new TypeError("attempted to set private field on non-instance");
          if (r.set) r.set.call(e, n);else {
            if (!r.writable) throw new TypeError("attempted to set read only private field");
            r.value = n;
          }
        }(this, o, r);
      }

      var n, r, v, b, h;
      return t = Object(i.inject)(a.i)(t, void 0, 2) || t, t = Object(i.inject)(c.d)(t, void 0, 1) || t, t = Object(i.inject)(u.c)(t, void 0, 0) || t, n = t, (r = [{
        key: "get",
        value: function value(e, t) {
          return this.performNetworkCall(e, "GET", t);
        }
      }, {
        key: "post",
        value: function value(e, t, n) {
          return this.performNetworkCall(e, "POST", t, n);
        }
      }, {
        key: "put",
        value: function value(e, t, n) {
          return this.performNetworkCall(e, "PUT", t, n);
        }
      }, {
        key: "delete",
        value: function value(e, t) {
          return this.performNetworkCall(e, "DELETE", t);
        }
      }, {
        key: "getRequestData",
        value: function value(e, t, n) {
          var r;
          return "jwe" === t && (r = new Headers({
            Authorization: "Basic ".concat(btoa("token:".concat(this.session.token)), ")"),
            "Content-Type": "application/json"
          })), {
            headers: r,
            method: e,
            body: JSON.stringify(n)
          };
        }
      }, {
        key: "getEnvironmentSpecificUrl",
        value: function value(e) {
          var t = "",
              n = this.envConfig.region || "";
          return n.startsWith("dev-") ? t = ".dev" : n.startsWith("stage-") && (t = ".stage"), e.replace("[environment]", t);
        }
      }, {
        key: "mapBody",
        value: function value(e) {
          return e ? Object(s.d)(e) : e;
        }
      }, {
        key: "performNetworkCall",
        value: (b = _regeneratorRuntime.mark(function t(n, r, i, u) {
          var c, f, d, v;
          return _regeneratorRuntime.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return c = this.getEnvironmentSpecificUrl(n), t.next = 3, fetch(c, this.getRequestData(r, i, this.mapBody(u)));

                case 3:
                  if ((f = t.sent).ok) {
                    t.next = 8;
                    break;
                  }

                  return d = {
                    module: "backend",
                    severity: a.b.Error,
                    source: Object(l.a)(e)
                  }, t.next = 8, p(this, o).call(this, f, d);

                case 8:
                  return t.next = 10, f.json();

                case 10:
                  return v = t.sent, t.abrupt("return", Object(s.c)(v));

                case 12:
                case "end":
                  return t.stop();
              }
            }
          }, t, this);
        }), h = function h() {
          var e = this,
              t = arguments;
          return new Promise(function (n, r) {
            var o = b.apply(e, t);

            function i(e) {
              f(o, n, r, i, a, "next", e);
            }

            function a(e) {
              f(o, n, r, i, a, "throw", e);
            }

            i(void 0);
          });
        }, function (e, t, n, r) {
          return h.apply(this, arguments);
        })
      }]) && d(n.prototype, r), v && d(n, v), t;
    }())) || r;
  }).call(this, "/index.js");
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return p;
  });
  var r,
      o,
      i = n(122),
      a = (n(5), n(3), n(6), n(11), n(7), n(8), n(0)),
      u = n(1),
      c = n(12);

  function s(e, t, n, r, o, i, a) {
    try {
      var u = e[i](a),
          c = u.value;
    } catch (e) {
      return void n(e);
    }

    u.done ? t(c) : Promise.resolve(c).then(r, o);
  }

  function l(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  var f = Object(a.injectable)()((o = new WeakMap(), r = function () {
    function e(t, n) {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e), o.set(this, {
        writable: !0,
        value: void 0
      }), this.syncAdapter = t, function (e, t, n) {
        var r = t.get(e);
        if (!r) throw new TypeError("attempted to set private field on non-instance");
        if (r.set) r.set.call(e, n);else {
          if (!r.writable) throw new TypeError("attempted to set read only private field");
          r.value = n;
        }
      }(this, o, n);
    }

    var t, n, r, i, f;
    return e = Object(a.inject)(u.j)(e, void 0, 1) || e, e = Object(a.inject)(c.d)(e, void 0, 0) || e, t = e, (n = [{
      key: "getWorkspaceStats",
      value: (i = _regeneratorRuntime.mark(function e() {
        var t;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.next = 2, this.syncAdapter.getSyncObjectByPath("/flex_insights/Maps/realtime_statistics_v1/Items/workspace");

              case 2:
                return t = e.sent, e.abrupt("return", t);

              case 4:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      }), f = function f() {
        var e = this,
            t = arguments;
        return new Promise(function (n, r) {
          var o = i.apply(e, t);

          function a(e) {
            s(o, n, r, a, u, "next", e);
          }

          function u(e) {
            s(o, n, r, a, u, "throw", e);
          }

          a(void 0);
        });
      }, function () {
        return f.apply(this, arguments);
      })
    }]) && l(t.prototype, n), r && l(t, r), e;
  }())) || r;

  function d(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  var p = function () {
    function e() {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e);
    }

    var t, n, r;
    return t = e, r = [{
      key: "with",
      value: function value(e) {
        e.bind("QueueStatsService").to(i.a).inSingletonScope(), e.bind("WorkspaceStatsService").to(f).inSingletonScope();
      }
    }], (n = null) && d(t.prototype, n), r && d(t, r), e;
  }();
}, function (e, t) {
  e.exports = require("lodash/camelCase");
}, function (e, t) {
  e.exports = require("lodash/snakeCase");
}, function (e, t) {
  e.exports = require("core-js/modules/es.object.get-own-property-descriptor.js");
}, function (e, t) {
  e.exports = require("core-js/modules/es.object.values.js");
}, function (e, t) {
  e.exports = require("core-js/modules/es.object.get-prototype-of.js");
}, function (e, t) {
  e.exports = require("core-js/modules/es.string.trim.js");
}, function (e, t) {
  e.exports = require("core-js/modules/es.string.match.js");
}, function (e, t) {
  e.exports = require("twilsock");
}, function (e, t) {
  e.exports = require("core-js/modules/es.regexp.to-string.js");
}, function (e, t) {
  e.exports = require("core-js/modules/es.array.reduce.js");
}, function (e, t) {
  e.exports = require("core-js/modules/es.array.slice.js");
}, function (e, t) {
  e.exports = require("core-js/modules/es.array.splice.js");
}, function (e, t, n) {
  "use strict";

  (function (e, r) {
    n.d(t, "a", function () {
      return k;
    });
    n(22), n(5), n(3), n(13), n(6), n(11), n(7), n(8);
    var o,
        i,
        a,
        u,
        c,
        s = n(0),
        l = n(1),
        f = n(19),
        d = n(4),
        p = n(9),
        v = n(21),
        b = n(101),
        h = n(2);

    function y(e, t, n, r, o, i, a) {
      try {
        var u = e[i](a),
            c = u.value;
      } catch (e) {
        return void n(e);
      }

      u.done ? t(c) : Promise.resolve(c).then(r, o);
    }

    function m(e) {
      return function () {
        var t = this,
            n = arguments;
        return new Promise(function (r, o) {
          var i = e.apply(t, n);

          function a(e) {
            y(i, r, o, a, u, "next", e);
          }

          function u(e) {
            y(i, r, o, a, u, "throw", e);
          }

          a(void 0);
        });
      };
    }

    function w(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function g(e, t) {
      var n = t.get(e);
      if (!n) throw new TypeError("attempted to get private field on non-instance");
      return n.get ? n.get.call(e) : n.value;
    }

    function j(e, t, n) {
      var r = t.get(e);
      if (!r) throw new TypeError("attempted to set private field on non-instance");
      if (r.set) r.set.call(e, n);else {
        if (!r.writable) throw new TypeError("attempted to set read only private field");
        r.value = n;
      }
      return n;
    }

    var k = Object(s.injectable)()((i = new WeakMap(), a = new WeakMap(), u = new WeakMap(), c = new WeakMap(), o = function () {
      function t(e, n, r, o) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), i.set(this, {
          writable: !0,
          value: void 0
        }), a.set(this, {
          writable: !0,
          value: void 0
        }), u.set(this, {
          writable: !0,
          value: void 0
        }), c.set(this, {
          writable: !0,
          value: void 0
        }), j(this, i, e), j(this, a, n), j(this, u, r(d.b.Auth)), j(this, c, o);
      }

      var n, o, y, k, O, S;
      return t = Object(s.inject)(l.i)(t, void 0, 3) || t, t = Object(s.inject)(d.d)(t, void 0, 2) || t, t = Object(s.inject)(v.a)(t, void 0, 1) || t, t = Object(s.inject)(p.d)(t, void 0, 0) || t, n = t, (o = [{
        key: "getIdpUrl",
        value: (S = m(_regeneratorRuntime.mark(function t(n) {
          var o, s, d, p, v, y, m, w;
          return _regeneratorRuntime.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return Object(f.c)(n.redirectUrl, "redirect url"), o = new Headers({
                    "Content-Type": "application/json"
                  }), s = b.a(n), d = g(this, i).authServiceUrl, p = g(this, a).accountSid, v = "".concat(d, "/").concat(p, "/authenticate"), t.next = 8, fetch(v, {
                    headers: o,
                    method: "POST",
                    body: s
                  });

                case 8:
                  if ((y = t.sent).ok) {
                    t.next = 13;
                    break;
                  }

                  return m = {
                    module: Object(h.b)(e),
                    resourceSid: p,
                    severity: l.b.Error,
                    source: Object(h.a)(r)
                  }, t.next = 13, g(this, c).call(this, y, m);

                case 13:
                  return t.next = 15, y.json();

                case 15:
                  if ((w = t.sent).location) {
                    t.next = 19;
                    break;
                  }

                  throw g(this, u).error("No redirect location from /authenticate request, data: ", w), new l.d("Invalid response from /authenticate endpoint");

                case 19:
                  return t.abrupt("return", w.location);

                case 20:
                case "end":
                  return t.stop();
              }
            }
          }, t, this);
        })), function (e) {
          return S.apply(this, arguments);
        })
      }, {
        key: "validateToken",
        value: (O = m(_regeneratorRuntime.mark(function t(n) {
          var o, u, s, d, p, v, b, y, m, w, j;
          return _regeneratorRuntime.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return Object(f.c)(n, "token"), o = new Headers({
                    Authorization: "Basic ".concat(btoa("token:".concat(n)), ")"),
                    "Content-Type": "application/json"
                  }), u = g(this, i).authServiceUrl, s = g(this, a).accountSid, d = "".concat(u, "/").concat(s, "/Tokens/validate"), t.next = 7, fetch(d, {
                    method: "POST",
                    headers: o,
                    body: JSON.stringify({
                      token: n
                    })
                  });

                case 7:
                  if ((p = t.sent).ok) {
                    t.next = 12;
                    break;
                  }

                  return v = {
                    module: Object(h.b)(e),
                    resourceSid: s,
                    severity: l.b.Error,
                    source: Object(h.a)(r)
                  }, t.next = 12, g(this, c).call(this, p, v);

                case 12:
                  return t.next = 14, p.json();

                case 14:
                  return b = t.sent, y = b.roles, m = b.valid, w = b.expiration, j = new Date(w), t.abrupt("return", {
                    roles: y,
                    valid: m,
                    dateExpired: j
                  });

                case 20:
                case "end":
                  return t.stop();
              }
            }
          }, t, this);
        })), function (e) {
          return O.apply(this, arguments);
        })
      }, {
        key: "refreshToken",
        value: (k = m(_regeneratorRuntime.mark(function t(n) {
          var o, u, s, d, p, v, b, y, m, w;
          return _regeneratorRuntime.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return Object(f.c)(n, "token"), o = g(this, i).authServiceUrl, u = g(this, a).accountSid, s = "".concat(o, "/").concat(u, "/Tokens/refresh"), d = new Headers({
                    "Content-Type": "application/json"
                  }), t.next = 7, fetch(s, {
                    headers: d,
                    method: "POST",
                    body: JSON.stringify({
                      token: n
                    })
                  });

                case 7:
                  if ((p = t.sent).ok) {
                    t.next = 12;
                    break;
                  }

                  return v = {
                    module: Object(h.b)(e),
                    resourceSid: u,
                    severity: l.b.Error,
                    source: Object(h.a)(r)
                  }, t.next = 12, g(this, c).call(this, p, v, "Could not refresh token");

                case 12:
                  return t.next = 14, p.json();

                case 14:
                  return b = t.sent, y = b.token, m = b.expiration, w = new Date(m), t.abrupt("return", {
                    token: y,
                    dateExpired: w
                  });

                case 19:
                case "end":
                  return t.stop();
              }
            }
          }, t, this);
        })), function (e) {
          return k.apply(this, arguments);
        })
      }]) && w(n.prototype, o), y && w(n, y), t;
    }())) || o;
  }).call(this, "/", "/index.js");
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return r;
  });
  n(42), n(60);

  function r(e) {
    var t,
        n = {
      products: ["flex"],
      resource: (t = e.redirectUrl, t.replace(/((Token|Expiration|Identity|Roles)=[^&]+[&]?)/g, "").replace(/[&?]$/, ""))
    };
    return JSON.stringify(n);
  }
}, function (e, t, n) {
  "use strict";

  (function (e, r) {
    n.d(t, "a", function () {
      return s;
    });
    n(92);
    var o = n(103),
        i = n.n(o),
        a = n(1),
        u = n(2),
        c = n(19);

    function s(t, n) {
      void 0 !== n && Object(c.d)(n, "userOptions");
      i()(t, n, function (t, n, o, i, c) {
        var s = Object.prototype.hasOwnProperty.call(i, o),
            l = Object.prototype.hasOwnProperty.call(Object.getPrototypeOf(i), o);

        if (!s && !l) {
          var f = {
            module: Object(u.b)(e),
            severity: a.b.Error,
            source: Object(u.a)(r)
          };
          throw new a.c(a.a.InvalidParams, f, "".concat(o, " is not a valid property"));
        }
      });
    }
  }).call(this, "/", "/index.js");
}, function (e, t) {
  e.exports = require("lodash/mergeWith");
}, function (e, t, n) {
  "use strict";

  (function (e, r) {
    n.d(t, "a", function () {
      return d;
    });
    n(3), n(13), n(42), n(130), n(94), n(60), n(93), n(8);
    var o = n(1),
        i = n(12),
        a = n(35),
        u = n(2);

    function c(e, t, n, r, o, i, a) {
      try {
        var u = e[i](a),
            c = u.value;
      } catch (e) {
        return void n(e);
      }

      u.done ? t(c) : Promise.resolve(c).then(r, o);
    }

    function s(e) {
      return function () {
        var t = this,
            n = arguments;
        return new Promise(function (r, o) {
          var i = e.apply(t, n);

          function a(e) {
            c(i, r, o, a, u, "next", e);
          }

          function u(e) {
            c(i, r, o, a, u, "throw", e);
          }

          a(void 0);
        });
      };
    }

    var l = /^([a-z]+-[a-z]+-\d+)$/;

    function f(e) {
      return function (e) {
        return !!e.accountSid;
      }(e) ? {
        paramName: "AccountSid",
        paramValue: e.accountSid
      } : {
        paramName: "RuntimeDomain",
        paramValue: function (e) {
          var t = e.trim();

          if (t.endsWith("/") && (t = t.replace(/\/$/, "")), !t.endsWith(".twil.io")) {
            var n = t.match(l);
            n && n[1] && (t += ".twil.io");
          }

          return t;
        }(e.runtimeDomain)
      };
    }

    function d(e, t) {
      return p.apply(this, arguments);
    }

    function p() {
      return (p = s(_regeneratorRuntime.mark(function t(n, c) {
        var s, l, d, p, v;
        return _regeneratorRuntime.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return s = n.get(i.a), l = n.get(o.j), d = f(c), t.next = 5, s.fetchPublicConfiguration(d.paramName, d.paramValue);

              case 5:
                return (p = t.sent) && p.configurations && p.configurations.length || (v = {
                  module: Object(u.b)(e),
                  severity: o.b.Error,
                  eventSource: Object(u.a)(r)
                }, l(o.a.SDK, v, "Invalid response from public configuration endpoint")), t.abrupt("return", Object(a.c)(p.configurations[0]));

              case 8:
              case "end":
                return t.stop();
            }
          }
        }, t);
      }))).apply(this, arguments);
    }
  }).call(this, "/", "/index.js");
}, function (e, t) {
  e.exports = require("lodash/mapKeys");
}, function (e, t) {
  e.exports = require("lodash/transform");
}, function (e, t, n) {
  "use strict";

  (function (e, r) {
    n.d(t, "a", function () {
      return F;
    });
    n(5), n(3), n(13), n(6), n(11), n(7), n(8);
    var o,
        i,
        a,
        u,
        c,
        s,
        l,
        f,
        d,
        p,
        v,
        b,
        h,
        y = n(0),
        m = n(59),
        w = n.n(m),
        g = n(65),
        j = n(15),
        k = n(36),
        O = n(27),
        S = n(10),
        x = n(1),
        E = n(4),
        T = n(9),
        P = n(14),
        C = n(108),
        R = n(2);

    function M(e, t, n, r, o, i, a) {
      try {
        var u = e[i](a),
            c = u.value;
      } catch (e) {
        return void n(e);
      }

      u.done ? t(c) : Promise.resolve(c).then(r, o);
    }

    function I(e) {
      return function () {
        var t = this,
            n = arguments;
        return new Promise(function (r, o) {
          var i = e.apply(t, n);

          function a(e) {
            M(i, r, o, a, u, "next", e);
          }

          function u(e) {
            M(i, r, o, a, u, "throw", e);
          }

          a(void 0);
        });
      };
    }

    function A(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function W(e, t) {
      var n = t.get(e);
      if (!n) throw new TypeError("attempted to get private field on non-instance");
      return n.get ? n.get.call(e) : n.value;
    }

    function D(e, t, n) {
      var r = t.get(e);
      if (!r) throw new TypeError("attempted to set private field on non-instance");
      if (r.set) r.set.call(e, n);else {
        if (!r.writable) throw new TypeError("attempted to set read only private field");
        r.value = n;
      }
      return n;
    }

    var F = Object(y.injectable)()((i = new WeakMap(), a = new WeakMap(), u = new WeakMap(), c = new WeakMap(), s = new WeakMap(), l = new WeakMap(), f = new WeakMap(), d = new WeakMap(), p = new WeakMap(), v = new WeakMap(), b = new WeakMap(), h = new WeakMap(), o = function () {
      function t(e, n, r, o, y, m, g, O) {
        var T = this;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), i.set(this, {
          writable: !0,
          value: void 0
        }), a.set(this, {
          writable: !0,
          value: void 0
        }), u.set(this, {
          writable: !0,
          value: void 0
        }), c.set(this, {
          writable: !0,
          value: void 0
        }), s.set(this, {
          writable: !0,
          value: void 0
        }), l.set(this, {
          writable: !0,
          value: void 0
        }), f.set(this, {
          writable: !0,
          value: void 0
        }), d.set(this, {
          writable: !0,
          value: void 0
        }), p.set(this, {
          writable: !0,
          value: function value() {
            Object(j.b)(T.getRawTwilsockClient(), W(T, l), k.b.TokenExpired, S.a.TokenExpired), Object(j.b)(T.getRawTwilsockClient(), W(T, l), k.b.TokenAboutToExpire, S.a.TokenAboutToExpire), Object(j.b)(T.getRawTwilsockClient(), W(T, l), k.b.StateChanged, S.a.StateChanged), Object(j.b)(T.getRawTwilsockClient(), W(T, l), k.b.Connected, S.a.Connected), Object(j.b)(T.getRawTwilsockClient(), W(T, l), k.b.Disconnected, S.a.Disconnected), W(T, b).call(T);
          }
        }), v.set(this, {
          writable: !0,
          value: function value() {
            var e = w.a.getLogger("twilsock");
            e.methodFactory = function (e) {
              return function () {
                var t;
                return (t = W(T, u))[e].apply(t, arguments);
              };
            }, e.setLevel("trace");
          }
        }), b.set(this, {
          writable: !0,
          value: function value() {
            T.getRawTwilsockClient().on(k.b.ConnectionError, function (e) {
              var t = e.errorCode,
                  n = e.metadata,
                  r = e.message,
                  o = new x.c(t || x.a.TwilsockConnectionError, n, r);
              W(T, l).emit(S.a.ConnectionError, o);
            });
          }
        }), h.set(this, {
          writable: !0,
          value: function value() {
            return new Promise(function (e, t) {
              if (T.getRawTwilsockClient().isConnected) e();else {
                var n = function n() {
                  return e();
                },
                    r = function r(e) {
                  return t(e);
                },
                    o = function o() {
                  T.removeListener(S.a.Connected, n), T.removeListener(S.a.ConnectionError, r);
                };

                T.on(S.a.Connected, function () {
                  o(), n();
                }), T.on(S.a.ConnectionError, function (e) {
                  o(), r(e);
                });
              }
            });
          }
        }), D(this, a, e), D(this, i, n), D(this, u, r(E.b.Twilsock)), W(this, u).debug("Twilsock constructed"), D(this, c, o), D(this, s, y), D(this, l, m), D(this, f, g), D(this, d, O);
      }

      var n, o, m, M, F, q, N;
      return t = Object(y.inject)(x.h)(t, void 0, 7) || t, t = Object(y.inject)(x.j)(t, void 0, 6) || t, t = Object(y.inject)(j.a)(t, void 0, 5) || t, t = Object(y.inject)(P.b)(t, void 0, 4) || t, t = Object(y.inject)(T.d)(t, void 0, 3) || t, t = Object(y.inject)(E.d)(t, void 0, 2) || t, t = Object(y.inject)(O.b)(t, void 0, 1) || t, t = Object(y.inject)(O.c)(t, void 0, 0) || t, n = t, (o = [{
        key: "connect",
        value: (N = I(_regeneratorRuntime.mark(function e(t) {
          var n;
          return _regeneratorRuntime.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (!this.twilsockClient) {
                    e.next = 2;
                    break;
                  }

                  throw new x.d("Twilsock connection already exists");

                case 2:
                  return n = {
                    region: W(this, s).region || W(this, c).region,
                    clientMetadata: {
                      type: "flex-sdk",
                      sdk: "JS",
                      sdkv: g.a,
                      app: W(this, s).appName,
                      appv: W(this, s).appVersion
                    }
                  }, this.twilsockClient = W(this, a).call(this, t, W(this, i), n), W(this, p).call(this), W(this, v).call(this), this.twilsockClient.connect(), e.next = 9, W(this, h).call(this);

                case 9:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function (e) {
          return N.apply(this, arguments);
        })
      }, {
        key: "updateToken",
        value: (q = I(_regeneratorRuntime.mark(function t(n) {
          var o, i;
          return _regeneratorRuntime.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  if (this.twilsockClient) {
                    t.next = 5;
                    break;
                  }

                  o = {
                    module: Object(R.b)(e),
                    severity: x.b.Error,
                    source: Object(R.a)(r)
                  }, W(this, f).call(this, x.a.InvalidState, o, "no twilsock client"), t.next = 15;
                  break;

                case 5:
                  return t.prev = 5, t.next = 8, this.twilsockClient.updateToken(n);

                case 8:
                  W(this, l).emit(S.a.TokenUpdated, n), t.next = 15;
                  break;

                case 11:
                  t.prev = 11, t.t0 = t.catch(5), i = {
                    module: Object(R.b)(e),
                    severity: x.b.Error,
                    source: "update Twilsock token"
                  }, W(this, d).call(this, t.t0, i);

                case 15:
                case "end":
                  return t.stop();
              }
            }
          }, t, this, [[5, 11]]);
        })), function (e) {
          return q.apply(this, arguments);
        })
      }, {
        key: "getRawTwilsockClient",
        value: function value() {
          if (!this.twilsockClient) throw new x.d("Twilsock hasn't been initialized");
          return this.twilsockClient;
        }
      }, {
        key: "post",
        value: (F = I(_regeneratorRuntime.mark(function t(n, o, i) {
          var a,
              c,
              s,
              l,
              d,
              p = this;
          return _regeneratorRuntime.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return t.prev = 0, t.next = 3, Object(C.a)(function () {
                    return p.getRawTwilsockClient().post(n, o, i);
                  }, W(this, u));

                case 3:
                  return t.abrupt("return", t.sent);

                case 6:
                  return t.prev = 6, t.t0 = t.catch(0), s = (null === (a = t.t0.body) || void 0 === a ? void 0 : a.code) || x.a.SDK, l = (null === (c = t.t0.body) || void 0 === c ? void 0 : c.message) || t.t0.message, d = {
                    module: Object(R.b)(e),
                    severity: x.b.Error,
                    source: Object(R.a)(r)
                  }, t.abrupt("return", W(this, f).call(this, s, d, l, t.t0));

                case 12:
                case "end":
                  return t.stop();
              }
            }
          }, t, this, [[0, 6]]);
        })), function (e, t, n) {
          return F.apply(this, arguments);
        })
      }, {
        key: "destroy",
        value: (M = I(_regeneratorRuntime.mark(function e() {
          var t, n;
          return _regeneratorRuntime.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (this.twilsockClient) {
                    e.next = 2;
                    break;
                  }

                  return e.abrupt("return");

                case 2:
                  return t = this.twilsockClient, n = new Promise(function (e) {
                    t.on(k.b.Disconnected, e);
                  }), e.next = 6, t.disconnect();

                case 6:
                  return e.next = 8, n;

                case 8:
                  delete this.twilsockClient, W(this, l).removeAllListeners();

                case 10:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function () {
          return M.apply(this, arguments);
        })
      }, {
        key: "on",
        value: function value(e, t) {
          return W(this, l).on(e, t), this;
        }
      }, {
        key: "removeListener",
        value: function value(e, t) {
          return W(this, l).removeListener(e, t), this;
        }
      }, {
        key: "isConnected",
        value: function value() {
          return !!this.twilsockClient && this.getRawTwilsockClient().isConnected;
        }
      }]) && A(n.prototype, o), m && A(n, m), t;
    }())) || o;
  }).call(this, "/", "/index.js");
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return u;
  });
  n(5), n(3), n(13), n(6), n(7), n(8);

  function r(e) {
    return (r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function o(e, t, n, r, o, i, a) {
    try {
      var u = e[i](a),
          c = u.value;
    } catch (e) {
      return void n(e);
    }

    u.done ? t(c) : Promise.resolve(c).then(r, o);
  }

  function i(e) {
    return function () {
      var t = this,
          n = arguments;
      return new Promise(function (r, i) {
        var a = e.apply(t, n);

        function u(e) {
          o(a, r, i, u, c, "next", e);
        }

        function c(e) {
          o(a, r, i, u, c, "throw", e);
        }

        u(void 0);
      });
    };
  }

  function a(e, t, n) {
    return "exponential" === n ? Math.pow(1.5, e) * t : (e + 1) * t;
  }

  function u(e, t) {
    return c.apply(this, arguments);
  }

  function c() {
    return (c = i(_regeneratorRuntime.mark(function e(t, n) {
      var o,
          i,
          u,
          c,
          s,
          l,
          f,
          d,
          p,
          v = arguments;
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              o = v.length > 2 && void 0 !== v[2] ? v[2] : 100, i = v.length > 3 && void 0 !== v[3] ? v[3] : 3, u = !(v.length > 4 && void 0 !== v[4]) || v[4], c = v.length > 5 && void 0 !== v[5] ? v[5] : "exponential", s = 0, l = 9e5, d = _regeneratorRuntime.mark(function e() {
                var r, d, p, v;
                return _regeneratorRuntime.wrap(function (e) {
                  for (;;) {
                    switch (e.prev = e.next) {
                      case 0:
                        return e.prev = 0, n && s > 0 && n.debug("Retry attempt: ", s), e.next = 4, t();

                      case 4:
                        return e.t0 = e.sent, e.abrupt("return", {
                          v: e.t0
                        });

                      case 8:
                        if (e.prev = 8, e.t1 = e.catch(0), p = null === (r = e.t1.reply) || void 0 === r || null === (d = r.status) || void 0 === d ? void 0 : d.code, !u || 429 === p) {
                          e.next = 13;
                          break;
                        }

                        return e.abrupt("return", {
                          v: Promise.reject(e.t1)
                        });

                      case 13:
                        if (!(s >= i - 1)) {
                          e.next = 16;
                          break;
                        }

                        return f = e.t1, e.abrupt("return", "break");

                      case 16:
                        return (v = a(s, o, c)) > l && (v = l), e.next = 20, new Promise(function (e) {
                          return setTimeout(e, v);
                        });

                      case 20:
                      case "end":
                        return e.stop();
                    }
                  }
                }, e, null, [[0, 8]]);
              });

            case 7:
              return e.delegateYield(d(), "t0", 8);

            case 8:
              if ("break" !== (p = e.t0)) {
                e.next = 11;
                break;
              }

              return e.abrupt("break", 14);

            case 11:
              if ("object" !== r(p)) {
                e.next = 13;
                break;
              }

              return e.abrupt("return", p.v);

            case 13:
              if (s++ < i - 1) {
                e.next = 7;
                break;
              }

            case 14:
              return e.abrupt("return", Promise.reject(f));

            case 15:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }))).apply(this, arguments);
  }
}, function (e, t, n) {
  "use strict";

  (function (e, r) {
    n.d(t, "a", function () {
      return u;
    });
    n(22), n(56), n(3), n(96), n(57);

    var o = n(18),
        i = n(1),
        a = n(2),
        u = function u(t) {
      return function (n) {
        return function (u, c, s) {
          var l = s.value,
              f = t.get(o.c);

          s.value = function () {
            var o = f.roles;

            if (!o.includes(n)) {
              var u = o.length ? o.toString() : "no role",
                  c = {
                module: Object(a.b)(e),
                severity: i.b.Error,
                source: Object(a.a)(r)
              },
                  s = t.get(i.j);
              s(i.a.Forbidden, c, "Expected the role ".concat(n, ", but got ").concat(u, " instead."));
            }

            for (var d = arguments.length, p = new Array(d), v = 0; v < d; v++) {
              p[v] = arguments[v];
            }

            var b = l.apply(this, p);
            return b;
          };
        };
      };
    };
  }).call(this, "/", "/index.js");
}, function (e, t, n) {
  "use strict";

  (function (e, r) {
    n.d(t, "a", function () {
      return W;
    });
    n(56), n(5), n(3), n(13), n(57), n(6), n(11), n(7), n(8);
    var o,
        i,
        a,
        u,
        c,
        s,
        l,
        f,
        d,
        p,
        v,
        b,
        h,
        y = n(0),
        m = n(52),
        w = n(32),
        g = n(16),
        j = n(1),
        k = n(4),
        O = n(10),
        S = n(50),
        x = n(15),
        E = n(9),
        T = n(14),
        P = n(2);

    function C(e, t, n, r, o, i, a) {
      try {
        var u = e[i](a),
            c = u.value;
      } catch (e) {
        return void n(e);
      }

      u.done ? t(c) : Promise.resolve(c).then(r, o);
    }

    function R(e) {
      return function () {
        var t = this,
            n = arguments;
        return new Promise(function (r, o) {
          var i = e.apply(t, n);

          function a(e) {
            C(i, r, o, a, u, "next", e);
          }

          function u(e) {
            C(i, r, o, a, u, "throw", e);
          }

          a(void 0);
        });
      };
    }

    function M(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function I(e, t) {
      var n = t.get(e);
      if (!n) throw new TypeError("attempted to get private field on non-instance");
      return n.get ? n.get.call(e) : n.value;
    }

    function A(e, t, n) {
      var r = t.get(e);
      if (!r) throw new TypeError("attempted to set private field on non-instance");
      if (r.set) r.set.call(e, n);else {
        if (!r.writable) throw new TypeError("attempted to set read only private field");
        r.value = n;
      }
      return n;
    }

    var W = Object(y.injectable)()((i = new WeakMap(), a = new WeakMap(), u = new WeakMap(), c = new WeakMap(), s = new WeakMap(), l = new WeakMap(), f = new WeakMap(), d = new WeakMap(), p = new WeakMap(), v = new WeakMap(), b = new WeakMap(), h = new WeakMap(), o = function () {
      function t(n, o, y, m, g, S, x, E, T) {
        var C,
            M = this;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), i.set(this, {
          writable: !0,
          value: void 0
        }), a.set(this, {
          writable: !0,
          value: void 0
        }), u.set(this, {
          writable: !0,
          value: void 0
        }), c.set(this, {
          writable: !0,
          value: void 0
        }), s.set(this, {
          writable: !0,
          value: void 0
        }), l.set(this, {
          writable: !0,
          value: void 0
        }), f.set(this, {
          writable: !0,
          value: void 0
        }), d.set(this, {
          writable: !0,
          value: void 0
        }), p.set(this, {
          writable: !0,
          value: void 0
        }), v.set(this, {
          writable: !0,
          value: void 0
        }), b.set(this, {
          writable: !0,
          value: (C = R(_regeneratorRuntime.mark(function t() {
            return _regeneratorRuntime.wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    return t.abrupt("return", new Promise(function (t, n) {
                      I(M, i).connectionState === w.c.Connected && t(), I(M, i).on(w.b.ConnectionStateChanged, function (o) {
                        if (I(M, u).debug("Connection state changed: ".concat(o)), o === w.c.Connected && t(), o === w.c.Error && I(M, i).removeAllListeners(), [w.c.Error, w.c.Disconnected, w.c.Denied].includes(o)) {
                          var a = {
                            module: Object(P.b)(e),
                            severity: j.b.Error,
                            source: Object(P.a)(r)
                          };
                          n(I(M, p).call(M, j.a.ConnectionError, a));
                        }
                      });
                    }));

                  case 1:
                  case "end":
                    return t.stop();
                }
              }
            }, t);
          })), function () {
            return C.apply(this, arguments);
          })
        }), h.set(this, {
          writable: !0,
          value: function value() {
            var t = function () {
              var t = R(_regeneratorRuntime.mark(function t() {
                var n;
                return _regeneratorRuntime.wrap(function (t) {
                  for (;;) {
                    switch (t.prev = t.next) {
                      case 0:
                        return t.prev = 0, t.next = 3, M.destroy();

                      case 3:
                        t.next = 9;
                        break;

                      case 5:
                        t.prev = 5, t.t0 = t.catch(0), n = {
                          module: Object(P.b)(e),
                          severity: j.b.Error,
                          source: Object(P.a)(r)
                        }, I(M, v).call(M, t.t0, n);

                      case 9:
                      case "end":
                        return t.stop();
                    }
                  }
                }, t, null, [[0, 5]]);
              }));
              return function () {
                return t.apply(this, arguments);
              };
            }();

            I(M, c).on(O.a.Disconnected, t);
          }
        }), A(this, a, n), A(this, u, o(k.b.Sync)), A(this, c, y), A(this, s, m), A(this, l, g), A(this, f, S), A(this, d, x), A(this, p, E), A(this, v, T);
      }

      var n, o, C, W, D, F;
      return t = Object(y.inject)(j.h)(t, void 0, 8) || t, t = Object(y.inject)(j.j)(t, void 0, 7) || t, t = Object(y.inject)(x.a)(t, void 0, 6) || t, t = Object(y.inject)(g.f)(t, void 0, 5) || t, t = Object(y.inject)(T.b)(t, void 0, 4) || t, t = Object(y.inject)(E.d)(t, void 0, 3) || t, t = Object(y.inject)(O.b)(t, void 0, 2) || t, t = Object(y.inject)(k.d)(t, void 0, 1) || t, t = Object(y.inject)(g.a)(t, void 0, 0) || t, n = t, (o = [{
        key: "isConnected",
        value: function value() {
          var e;
          return (null === (e = I(this, i)) || void 0 === e ? void 0 : e.connectionState) === w.c.Connected;
        }
      }, {
        key: "connect",
        value: (F = R(_regeneratorRuntime.mark(function e(t, n) {
          var r;
          return _regeneratorRuntime.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (!I(this, i)) {
                    e.next = 2;
                    break;
                  }

                  return e.abrupt("return");

                case 2:
                  return r = {
                    region: I(this, l).region || I(this, s).region,
                    twilsockClient: I(this, c).getRawTwilsockClient(),
                    productId: n
                  }, A(this, i, new (I(this, a))(t, r)), e.next = 6, I(this, b).call(this);

                case 6:
                  I(this, h).call(this);

                case 7:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function (e, t) {
          return F.apply(this, arguments);
        })
      }, {
        key: "getMapById",
        value: (D = R(_regeneratorRuntime.mark(function e(t) {
          var n,
              r = arguments;
          return _regeneratorRuntime.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (n = r.length > 1 && void 0 !== r[1] ? r[1] : m.a.OpenExisting, I(this, i)) {
                    e.next = 3;
                    break;
                  }

                  throw new j.d("Sync client hasn't been initialized");

                case 3:
                  return e.abrupt("return", I(this, f).call(this, I(this, i), t, n));

                case 4:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function (e) {
          return D.apply(this, arguments);
        })
      }, {
        key: "destroy",
        value: (W = R(_regeneratorRuntime.mark(function e() {
          return _regeneratorRuntime.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (I(this, d).emit(S.a.Destroyed), I(this, i)) {
                    e.next = 3;
                    break;
                  }

                  return e.abrupt("return");

                case 3:
                  return e.next = 5, I(this, i).shutdown();

                case 5:
                  I(this, i).removeAllListeners(), I(this, u).debug("Sync client destroyed");

                case 7:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function () {
          return W.apply(this, arguments);
        })
      }, {
        key: "on",
        value: function value(e, t) {
          return I(this, d).on(e, t), this;
        }
      }, {
        key: "removeListener",
        value: function value(e, t) {
          return I(this, d).removeListener(e, t), this;
        }
      }]) && M(n.prototype, o), C && M(n, C), t;
    }())) || o;
  }).call(this, "/", "/index.js");
}, function (e, t, n) {
  "use strict";

  (function (e, r) {
    n.d(t, "a", function () {
      return s;
    });
    n(72), n(3), n(13), n(8);
    var o = n(16),
        i = n(1),
        a = n(2);

    function u(e, t, n, r, o, i, a) {
      try {
        var u = e[i](a),
            c = u.value;
      } catch (e) {
        return void n(e);
      }

      u.done ? t(c) : Promise.resolve(c).then(r, o);
    }

    function c(e) {
      return function () {
        var t = this,
            n = arguments;
        return new Promise(function (r, o) {
          var i = e.apply(t, n);

          function a(e) {
            u(i, r, o, a, c, "next", e);
          }

          function c(e) {
            u(i, r, o, a, c, "throw", e);
          }

          a(void 0);
        });
      };
    }

    function s(e, t, n, r) {
      return l.apply(this, arguments);
    }

    function l() {
      return (l = c(_regeneratorRuntime.mark(function t(n, u, c, s) {
        var l, f, d, p, v, b;
        return _regeneratorRuntime.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return t.prev = 0, t.next = 3, u.map({
                  id: c,
                  mode: s
                });

              case 3:
                return l = t.sent, f = n.get(o.c), d = n.get(o.e), p = new f(l, d), t.abrupt("return", p);

              case 10:
                return t.prev = 10, t.t0 = t.catch(0), v = {
                  module: Object(a.b)(e),
                  resourceSid: c,
                  severity: i.b.Error,
                  source: Object(a.a)(r)
                }, b = n.get(i.j), t.abrupt("return", b(t.t0.code || i.a.SDK, v, t.t0.message, t.t0));

              case 15:
              case "end":
                return t.stop();
            }
          }
        }, t, null, [[0, 10]]);
      }))).apply(this, arguments);
    }
  }).call(this, "/", "/index.js");
}, function (e, t, n) {
  "use strict";

  (function (e, r) {
    n.d(t, "a", function () {
      return s;
    });
    n(3), n(13), n(8);
    var o = n(16),
        i = n(1),
        a = n(2);

    function u(e, t, n, r, o, i, a) {
      try {
        var u = e[i](a),
            c = u.value;
      } catch (e) {
        return void n(e);
      }

      u.done ? t(c) : Promise.resolve(c).then(r, o);
    }

    function c(e) {
      return function () {
        var t = this,
            n = arguments;
        return new Promise(function (r, o) {
          var i = e.apply(t, n);

          function a(e) {
            u(i, r, o, a, c, "next", e);
          }

          function c(e) {
            u(i, r, o, a, c, "throw", e);
          }

          a(void 0);
        });
      };
    }

    function s(e, t, n) {
      return l.apply(this, arguments);
    }

    function l() {
      return (l = c(_regeneratorRuntime.mark(function t(n, u, c) {
        var s, l, f, d, p;
        return _regeneratorRuntime.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return t.prev = 0, t.next = 3, u.get(c);

              case 3:
                return s = t.sent, l = n.get(o.b), f = new l(u, s), t.abrupt("return", f);

              case 9:
                return t.prev = 9, t.t0 = t.catch(0), d = {
                  module: Object(a.b)(e),
                  severity: i.b.Error,
                  source: Object(a.a)(r)
                }, p = n.get(i.j), t.abrupt("return", p(t.t0.code || i.a.SDK, d, t.t0.message, t.t0));

              case 14:
              case "end":
                return t.stop();
            }
          }
        }, t, null, [[0, 9]]);
      }))).apply(this, arguments);
    }
  }).call(this, "/", "/index.js");
}, function (e, t, n) {
  "use strict";

  (function (e, r) {
    n.d(t, "a", function () {
      return l;
    });
    n(3), n(13), n(8);
    var o = n(16),
        i = n(18),
        a = n(50),
        u = n(1),
        c = n(2);

    function s(e, t, n, r, o, i, a) {
      try {
        var u = e[i](a),
            c = u.value;
      } catch (e) {
        return void n(e);
      }

      u.done ? t(c) : Promise.resolve(c).then(r, o);
    }

    var l = function () {
      var t,
          n = (t = _regeneratorRuntime.mark(function t(n, s) {
        var l, f, d, p, v, b;
        return _regeneratorRuntime.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                if (l = n.get(o.d), f = l.get(s)) {
                  t.next = 19;
                  break;
                }

                return d = function d() {
                  l.delete(s);
                }, f = n.get(o.h), l.set(s, f), f.on(a.a.Destroyed, d), p = n.get(i.c), t.prev = 8, t.next = 11, f.connect(p.token, s);

              case 11:
                t.next = 19;
                break;

              case 13:
                t.prev = 13, t.t0 = t.catch(8), v = n.get(u.h), l.delete(s), b = {
                  module: Object(c.b)(e),
                  resourceSid: s,
                  severity: u.b.Error,
                  source: Object(c.a)(r)
                }, v(t.t0, b);

              case 19:
                return t.abrupt("return", f);

              case 20:
              case "end":
                return t.stop();
            }
          }
        }, t, null, [[8, 13]]);
      }), function () {
        var e = this,
            n = arguments;
        return new Promise(function (r, o) {
          var i = t.apply(e, n);

          function a(e) {
            s(i, r, o, a, u, "next", e);
          }

          function u(e) {
            s(i, r, o, a, u, "throw", e);
          }

          a(void 0);
        });
      });
      return function (e, t) {
        return n.apply(this, arguments);
      };
    }();
  }).call(this, "/", "/index.js");
}, function (e, t, n) {
  "use strict";

  (function (e, r) {
    n.d(t, "a", function () {
      return x;
    });
    n(22), n(39), n(5), n(97), n(98), n(3), n(13), n(6), n(11), n(40), n(7), n(8);
    var o,
        i,
        a,
        u,
        c,
        s,
        l,
        f = n(0),
        d = n(4),
        p = n(115),
        v = n(12),
        b = n(1),
        h = n(19),
        y = n(2);

    function m(e) {
      return function (e) {
        if (Array.isArray(e)) return w(e);
      }(e) || function (e) {
        if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e);
      }(e) || function (e, t) {
        if (!e) return;
        if ("string" == typeof e) return w(e, t);
        var n = Object.prototype.toString.call(e).slice(8, -1);
        "Object" === n && e.constructor && (n = e.constructor.name);
        if ("Map" === n || "Set" === n) return Array.from(e);
        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return w(e, t);
      }(e) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function w(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var n = 0, r = new Array(t); n < t; n++) {
        r[n] = e[n];
      }

      return r;
    }

    function g(e, t, n, r, o, i, a) {
      try {
        var u = e[i](a),
            c = u.value;
      } catch (e) {
        return void n(e);
      }

      u.done ? t(c) : Promise.resolve(c).then(r, o);
    }

    function j(e) {
      return function () {
        var t = this,
            n = arguments;
        return new Promise(function (r, o) {
          var i = e.apply(t, n);

          function a(e) {
            g(i, r, o, a, u, "next", e);
          }

          function u(e) {
            g(i, r, o, a, u, "throw", e);
          }

          a(void 0);
        });
      };
    }

    function k(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function O(e, t) {
      var n = t.get(e);
      if (!n) throw new TypeError("attempted to get private field on non-instance");
      return n.get ? n.get.call(e) : n.value;
    }

    function S(e, t, n) {
      var r = t.get(e);
      if (!r) throw new TypeError("attempted to set private field on non-instance");
      if (r.set) r.set.call(e, n);else {
        if (!r.writable) throw new TypeError("attempted to set read only private field");
        r.value = n;
      }
      return n;
    }

    var x = Object(f.injectable)()((i = new WeakMap(), a = new WeakMap(), u = new WeakMap(), c = new WeakMap(), s = new WeakMap(), l = new WeakMap(), o = function () {
      function t(n, o, f, p) {
        var v,
            h = this;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), i.set(this, {
          writable: !0,
          value: void 0
        }), a.set(this, {
          writable: !0,
          value: void 0
        }), u.set(this, {
          writable: !0,
          value: !1
        }), c.set(this, {
          writable: !0,
          value: void 0
        }), s.set(this, {
          writable: !0,
          value: void 0
        }), l.set(this, {
          writable: !0,
          value: (v = j(_regeneratorRuntime.mark(function t() {
            var n,
                o,
                s,
                l,
                f,
                d,
                p,
                v,
                m = arguments;
            return _regeneratorRuntime.wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    for (n = m.length, o = new Array(n), s = 0; s < n; s++) {
                      o[s] = m[s];
                    }

                    return O(h, i).debug("Sending", o.length, "telemetry events"), O(h, i).trace("Events", o), l = {
                      number_of_successful_events: 0,
                      number_of_failed_events: 0
                    }, t.prev = 4, t.next = 7, O(h, a).postTelemetryEvents({
                      events: o
                    });

                  case 7:
                    f = t.sent, (d = f.body) && (l = d, O(h, i).debug("Telemetry sent successfully")), t.next = 18;
                    break;

                  case 12:
                    t.prev = 12, t.t0 = t.catch(4), 409 !== (null === (p = t.t0.wrappedError) || void 0 === p ? void 0 : p.status) && (v = {
                      module: Object(y.b)(e),
                      severity: b.b.Error,
                      eventSource: Object(y.a)(r)
                    }, O(h, c).call(h, t.t0, v)), O(h, i).warn("Telemetry is disabled for this account"), S(h, u, !0);

                  case 18:
                    return t.abrupt("return", l);

                  case 19:
                  case "end":
                    return t.stop();
                }
              }
            }, t, null, [[4, 12]]);
          })), function () {
            return v.apply(this, arguments);
          })
        }), S(this, i, n(d.c.TelemetryProcessor)), S(this, a, o), S(this, s, f), S(this, c, p);
      }

      var n, o, w, g;
      return t = Object(f.inject)(b.h)(t, void 0, 3) || t, t = Object(f.inject)(b.j)(t, void 0, 2) || t, t = Object(f.inject)(v.e)(t, void 0, 1) || t, t = Object(f.inject)(d.d)(t, void 0, 0) || t, n = t, (o = [{
        key: "processEvents",
        value: (g = j(_regeneratorRuntime.mark(function e(t, n, r) {
          var o,
              a,
              c,
              f,
              d,
              v,
              b,
              y,
              w,
              g,
              j,
              k,
              S = arguments;
          return _regeneratorRuntime.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  for (Object(h.c)(t, "payload type"), void 0 !== n && Object(h.c)(n, "group name"), o = S.length, a = new Array(o > 3 ? o - 3 : 0), c = 3; c < o; c++) {
                    a[c - 3] = S[c];
                  }

                  if (a.forEach(function (e) {
                    var t = e.eventName,
                        n = e.eventSource;
                    Object(h.c)(t, "event name"), void 0 !== n && Object(h.c)(n, "event source");
                  }), !O(this, u)) {
                    e.next = 7;
                    break;
                  }

                  return O(this, i).trace("Events not sent: telemetry disabled"), e.abrupt("return", {
                    eventsNotProcessed: a.length,
                    eventsSucceeded: 0,
                    eventsFailed: 0
                  });

                case 7:
                  if (O(this, i).debug("common attributes:", r), f = p.a.apply(void 0, [O(this, s), t, n, r].concat(a)), d = 0, v = 0, !f.length) {
                    e.next = 19;
                    break;
                  }

                  for (y = [], w = 0; w < f.length; w += 50) {
                    b = f.slice(w, w + 50), y.push((g = O(this, l)).call.apply(g, [this].concat(m(b))));
                  }

                  return e.next = 16, Promise.all(y);

                case 16:
                  j = e.sent, d = j.reduce(function (e, t) {
                    return e + t.number_of_successful_events;
                  }, 0), v = j.reduce(function (e, t) {
                    return e + t.number_of_failed_events;
                  }, 0);

                case 19:
                  return k = a.length - d - v, e.abrupt("return", {
                    eventsSucceeded: d,
                    eventsFailed: v,
                    eventsNotProcessed: k
                  });

                case 21:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function (e, t, n) {
          return g.apply(this, arguments);
        })
      }]) && k(n.prototype, o), w && k(n, w), t;
    }())) || o;
  }).call(this, "/", "/index.js");
}, function (e, t, n) {
  "use strict";

  (function (e, r) {
    n.d(t, "a", function () {
      return f;
    });
    n(72);
    var o = n(35),
        i = n(1),
        a = n(2);

    function u(e, t) {
      var n = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }

      return n;
    }

    function c(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? u(Object(n), !0).forEach(function (t) {
          s(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : u(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }

      return e;
    }

    function s(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    function l(t, n, u, s, l) {
      var f,
          d = void 0 === l ? {} : Object(o.a)(l),
          p = c(c({}, Object(o.a)(u)), {}, {
        client_timestamp: new Date().toISOString(),
        event_group: s
      });
      if (f = p, Object.prototype.hasOwnProperty.call(f, "event_name") && Object.prototype.hasOwnProperty.call(f, "client_timestamp")) return {
        payload_type: n,
        payload: c(c({}, p), d)
      };
      var v = {
        module: Object(a.b)(e),
        severity: i.b.Error,
        source: Object(a.a)(r)
      };
      return t(i.a.InvalidParams, v, "Telemetry event has missing fields");
    }

    function f(e, t, n, r) {
      for (var o = arguments.length, i = new Array(o > 4 ? o - 4 : 0), a = 4; a < o; a++) {
        i[a - 4] = arguments[a];
      }

      return i.map(function (o) {
        return l(e, t, o, n, r);
      });
    }
  }).call(this, "/", "/index.js");
}, function (e, t, n) {
  "use strict";

  (function (e, r) {
    n.d(t, "a", function () {
      return l;
    });
    n(3), n(13), n(8);
    var o = n(25),
        i = n(12),
        a = n(1),
        u = n(2);

    function c(e, t, n, r, o, i, a) {
      try {
        var u = e[i](a),
            c = u.value;
      } catch (e) {
        return void n(e);
      }

      u.done ? t(c) : Promise.resolve(c).then(r, o);
    }

    function s(e) {
      return function () {
        var t = this,
            n = arguments;
        return new Promise(function (r, o) {
          var i = e.apply(t, n);

          function a(e) {
            c(i, r, o, a, u, "next", e);
          }

          function u(e) {
            c(i, r, o, a, u, "throw", e);
          }

          a(void 0);
        });
      };
    }

    function l(e, t) {
      return f.apply(this, arguments);
    }

    function f() {
      return (f = s(_regeneratorRuntime.mark(function t(n, c) {
        var s, l, f, d, p, v, b, h, y, m;
        return _regeneratorRuntime.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return s = n.get(o.e), l = s(c), f = n.get(o.a), d = n.get(i.c), p = n.get(a.h), v = n.get(a.g), t.prev = 6, t.next = 9, d.getMetadata(c);

              case 9:
                return b = t.sent, h = new f(c, d, l, b, p, v), t.abrupt("return", h);

              case 14:
                return t.prev = 14, t.t0 = t.catch(6), (null === (y = t.t0.wrappedError) || void 0 === y ? void 0 : y.code) === a.e.SyncNameNotFoundError && v(t.t0, "Metadata statistics of the queue: ".concat(c)), m = {
                  module: Object(u.b)(e),
                  resourceSid: c,
                  severity: a.b.Error,
                  source: Object(u.a)(r)
                }, t.abrupt("return", p(t.t0, m));

              case 19:
              case "end":
                return t.stop();
            }
          }
        }, t, null, [[6, 14]]);
      }))).apply(this, arguments);
    }
  }).call(this, "/", "/index.js");
}, function (e, t, n) {
  "use strict";

  (function (e, r) {
    n.d(t, "a", function () {
      return j;
    });
    n(39), n(74), n(5), n(99), n(90), n(3), n(13), n(6), n(11), n(40), n(7), n(8);
    var o,
        i,
        a,
        u,
        c,
        s,
        l,
        f = n(1),
        d = n(62),
        p = n(2),
        v = n(53);

    function b(e, t, n, r, o, i, a) {
      try {
        var u = e[i](a),
            c = u.value;
      } catch (e) {
        return void n(e);
      }

      u.done ? t(c) : Promise.resolve(c).then(r, o);
    }

    function h(e) {
      return function () {
        var t = this,
            n = arguments;
        return new Promise(function (r, o) {
          var i = e.apply(t, n);

          function a(e) {
            b(i, r, o, a, u, "next", e);
          }

          function u(e) {
            b(i, r, o, a, u, "throw", e);
          }

          a(void 0);
        });
      };
    }

    function y(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function m(e, t) {
      var n = t.get(e);
      if (!n) throw new TypeError("attempted to get private field on non-instance");
      return n.get ? n.get.call(e) : n.value;
    }

    function w(e, t, n) {
      var r = t.get(e);
      if (!r) throw new TypeError("attempted to set private field on non-instance");
      if (r.set) r.set.call(e, n);else {
        if (!r.writable) throw new TypeError("attempted to set read only private field");
        r.value = n;
      }
      return n;
    }

    function g(e, t, n, r, o) {
      var i = {};
      return Object.keys(r).forEach(function (e) {
        i[e] = r[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = n.slice().reverse().reduce(function (n, r) {
        return r(e, t, n) || n;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }

    var j = (i = new WeakMap(), a = new WeakMap(), u = new WeakMap(), c = new WeakMap(), s = new WeakMap(), l = new WeakMap(), g((o = function () {
      function t(e, n, r, o, f, p) {
        var v = this;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), i.set(this, {
          writable: !0,
          value: void 0
        }), a.set(this, {
          writable: !0,
          value: void 0
        }), u.set(this, {
          writable: !0,
          value: []
        }), c.set(this, {
          writable: !0,
          value: void 0
        }), s.set(this, {
          writable: !0,
          value: void 0
        }), l.set(this, {
          writable: !0,
          value: function value() {
            m(v, u).forEach(function (e) {
              e(d.a.Metadata);
            });
          }
        }), this.sid = e, w(this, a, n), this.tasks = r, w(this, i, o.getSubscribable()), w(this, c, f), w(this, s, p);
      }

      var n, o, v, b, g, j;
      return n = t, (o = [{
        key: "dateUpdated",
        get: function get() {
          return m(this, i).timestampUpdated;
        }
      }, {
        key: "friendlyName",
        get: function get() {
          return m(this, i).queueFriendlyName || "";
        }
      }, {
        key: "subscribe",
        value: function value(e) {
          m(this, u).push(e), 1 === m(this, u).length && m(this, i).subscribe(m(this, l));
        }
      }, {
        key: "unsubscribe",
        value: function value(e) {
          var t = m(this, u).indexOf(e);
          t >= 0 && m(this, u).splice(t, 1), 0 === m(this, u).length && m(this, i).unsubscribe(m(this, l));
        }
      }, {
        key: "getWorkerStats",
        value: (j = h(_regeneratorRuntime.mark(function t() {
          var n, o, i, u;
          return _regeneratorRuntime.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return t.prev = 0, t.next = 3, m(this, a).getWorkerStats(this.sid);

                case 3:
                  return n = t.sent, o = {
                    mapKeysToCamelCase: !0,
                    dateFields: ["timestampUpdated"]
                  }, t.abrupt("return", n.getSubscribable(o));

                case 8:
                  if (t.prev = 8, t.t0 = t.catch(0), (null === (i = t.t0.wrappedError) || void 0 === i ? void 0 : i.code) !== f.e.SyncNameNotFoundError) {
                    t.next = 12;
                    break;
                  }

                  return t.abrupt("return", m(this, s).call(this, t.t0, "Worker statistics of the queue: ".concat(this.sid)));

                case 12:
                  return u = {
                    module: Object(p.b)(e),
                    resourceSid: this.sid,
                    severity: f.b.Error,
                    source: Object(p.a)(r)
                  }, t.abrupt("return", m(this, c).call(this, t.t0, u));

                case 14:
                case "end":
                  return t.stop();
              }
            }
          }, t, this, [[0, 8]]);
        })), function () {
          return j.apply(this, arguments);
        })
      }, {
        key: "getTaskChannelStats",
        value: (g = h(_regeneratorRuntime.mark(function e() {
          return _regeneratorRuntime.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", Promise.reject(new Error("Not implemented")));

                case 1:
                case "end":
                  return e.stop();
              }
            }
          }, e);
        })), function () {
          return g.apply(this, arguments);
        })
      }, {
        key: "getAllTaskChannelStats",
        value: (b = h(_regeneratorRuntime.mark(function e() {
          return _regeneratorRuntime.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", Promise.reject(new Error("Not implemented")));

                case 1:
                case "end":
                  return e.stop();
              }
            }
          }, e);
        })), function () {
          return b.apply(this, arguments);
        })
      }]) && y(n.prototype, o), v && y(n, v), t;
    }()).prototype, "dateUpdated", [v.a], Object.getOwnPropertyDescriptor(o.prototype, "dateUpdated"), o.prototype), g(o.prototype, "friendlyName", [v.a], Object.getOwnPropertyDescriptor(o.prototype, "friendlyName"), o.prototype), o);
  }).call(this, "/", "/index.js");
}, function (e, t, n) {
  "use strict";

  (function (e, r) {
    n.d(t, "a", function () {
      return h;
    });
    n(22), n(5), n(3), n(6), n(11), n(7), n(8);
    var o = n(19),
        i = n(1),
        a = n(2);

    function u(e, t, n, r, o, i, a) {
      try {
        var u = e[i](a),
            c = u.value;
      } catch (e) {
        return void n(e);
      }

      u.done ? t(c) : Promise.resolve(c).then(r, o);
    }

    function c(e) {
      return function () {
        var t = this,
            n = arguments;
        return new Promise(function (r, o) {
          var i = e.apply(t, n);

          function a(e) {
            u(i, r, o, a, c, "next", e);
          }

          function c(e) {
            u(i, r, o, a, c, "throw", e);
          }

          a(void 0);
        });
      };
    }

    function s(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function l(e, t) {
      var n = t.get(e);
      if (!n) throw new TypeError("attempted to get private field on non-instance");
      return n.get ? n.get.call(e) : n.value;
    }

    function f(e, t, n) {
      var r = t.get(e);
      if (!r) throw new TypeError("attempted to set private field on non-instance");
      if (r.set) r.set.call(e, n);else {
        if (!r.writable) throw new TypeError("attempted to set read only private field");
        r.value = n;
      }
      return n;
    }

    var d = new WeakMap(),
        p = new WeakMap(),
        v = new WeakMap(),
        b = new WeakMap(),
        h = function () {
      function t(e, n, r, o) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), d.set(this, {
          writable: !0,
          value: void 0
        }), p.set(this, {
          writable: !0,
          value: void 0
        }), v.set(this, {
          writable: !0,
          value: void 0
        }), b.set(this, {
          writable: !0,
          value: void 0
        }), f(this, p, e), f(this, d, n), f(this, v, r), f(this, b, o);
      }

      var n, u, h, y, m;
      return n = t, (u = [{
        key: "getCurrentTasks",
        value: (m = c(_regeneratorRuntime.mark(function t() {
          var n, o, u, c, s;
          return _regeneratorRuntime.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return t.prev = 0, t.next = 3, l(this, d).getCurrentTasksStats(l(this, p));

                case 3:
                  return n = t.sent, o = {
                    mapKeysToCamelCase: !0,
                    dateFields: ["timestampUpdated", "longestTaskWaitingFrom"]
                  }, u = n.getSubscribableForSubKey("queue", o), t.abrupt("return", u);

                case 9:
                  return t.prev = 9, t.t0 = t.catch(0), (null === (c = t.t0.wrappedError) || void 0 === c ? void 0 : c.code) === i.e.SyncNameNotFoundError && l(this, b).call(this, t.t0, "Statistics for current tasks of the queue: ".concat(l(this, p))), s = {
                    module: Object(a.b)(e),
                    resourceSid: l(this, p),
                    severity: i.b.Error,
                    source: Object(a.a)(r)
                  }, t.abrupt("return", l(this, v).call(this, t.t0, s));

                case 14:
                case "end":
                  return t.stop();
              }
            }
          }, t, this, [[0, 9]]);
        })), function () {
          return m.apply(this, arguments);
        })
      }, {
        key: "getForPeriod",
        value: (y = c(_regeneratorRuntime.mark(function t(n) {
          var u, c, s, f, h, y;
          return _regeneratorRuntime.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return Object(o.c)(n, "period"), t.prev = 1, t.next = 4, l(this, d).getHistoricalStats(l(this, p), n);

                case 4:
                  return u = t.sent, c = {
                    mapKeysToCamelCase: !0,
                    dateFields: ["timestampUpdated"]
                  }, s = u.getSubscribableForSubKey("queue", c), t.abrupt("return", s);

                case 10:
                  return t.prev = 10, t.t0 = t.catch(1), (null === (f = t.t0.wrappedError) || void 0 === f ? void 0 : f.code) === i.e.SyncNameNotFoundError ? l(this, b).call(this, t.t0, "Historical statistics for the period ".concat(n, " of the queue: ").concat(l(this, p))) : (null === (h = t.t0.wrappedError) || void 0 === h ? void 0 : h.code) === i.e.SyncMapItemNotFoundError && l(this, b).call(this, t.t0, "Historical statistics for the period ".concat(n, " of the queue: ").concat(l(this, p), " missing. \n                    Maybe no accepted or cancelled tasks during this period.")), y = {
                    module: Object(a.b)(e),
                    resourceSid: l(this, p),
                    severity: i.b.Error,
                    source: Object(a.a)(r)
                  }, t.abrupt("return", l(this, v).call(this, t.t0, y));

                case 15:
                case "end":
                  return t.stop();
              }
            }
          }, t, this, [[1, 10]]);
        })), function (e) {
          return y.apply(this, arguments);
        })
      }]) && s(n.prototype, u), h && s(n, h), t;
    }();
  }).call(this, "/", "/index.js");
}, function (e, t, n) {
  "use strict";

  (function (e, r) {
    n.d(t, "a", function () {
      return O;
    });
    n(5), n(3), n(6), n(11), n(7), n(8);
    var o,
        i,
        a,
        u,
        c,
        s,
        l,
        f,
        d = n(0),
        p = n(1),
        v = n(25),
        b = n(120),
        h = n(12),
        y = n(2);

    function m(e, t, n, r, o, i, a) {
      try {
        var u = e[i](a),
            c = u.value;
      } catch (e) {
        return void n(e);
      }

      u.done ? t(c) : Promise.resolve(c).then(r, o);
    }

    function w(e) {
      return function () {
        var t = this,
            n = arguments;
        return new Promise(function (r, o) {
          var i = e.apply(t, n);

          function a(e) {
            m(i, r, o, a, u, "next", e);
          }

          function u(e) {
            m(i, r, o, a, u, "throw", e);
          }

          a(void 0);
        });
      };
    }

    function g(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function j(e, t) {
      var n = t.get(e);
      if (!n) throw new TypeError("attempted to get private field on non-instance");
      return n.get ? n.get.call(e) : n.value;
    }

    function k(e, t, n) {
      var r = t.get(e);
      if (!r) throw new TypeError("attempted to set private field on non-instance");
      if (r.set) r.set.call(e, n);else {
        if (!r.writable) throw new TypeError("attempted to set read only private field");
        r.value = n;
      }
      return n;
    }

    var O = Object(d.injectable)()((i = new WeakMap(), a = new WeakMap(), u = new WeakMap(), c = new WeakMap(), s = new WeakMap(), l = new WeakMap(), f = new WeakMap(), o = function () {
      function t(n, o, d, v, b, h) {
        var m = this;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), i.set(this, {
          writable: !0,
          value: void 0
        }), a.set(this, {
          writable: !0,
          value: void 0
        }), u.set(this, {
          writable: !0,
          value: void 0
        }), c.set(this, {
          writable: !0,
          value: void 0
        }), s.set(this, {
          writable: !0,
          value: void 0
        }), l.set(this, {
          writable: !0,
          value: void 0
        }), f.set(this, {
          writable: !0,
          value: function value() {
            if (!(j(m, a).hasRole("supervisor") || j(m, a).hasRole("admin"))) {
              var t = {
                module: Object(y.b)(e),
                severity: p.b.Error,
                source: Object(y.a)(r)
              };
              j(m, c).call(m, p.a.PermissionDeniedError, t);
            }
          }
        }), k(this, i, n), k(this, a, o), k(this, u, d), k(this, c, v), k(this, l, h), k(this, s, b);
      }

      var n, o, m, O, S;
      return t = Object(d.inject)(p.g)(t, void 0, 5) || t, t = Object(d.inject)(p.h)(t, void 0, 4) || t, t = Object(d.inject)(p.j)(t, void 0, 3) || t, t = Object(d.inject)(h.g)(t, void 0, 2) || t, t = Object(d.inject)(b.a)(t, void 0, 1) || t, t = Object(d.inject)(v.c)(t, void 0, 0) || t, n = t, (o = [{
        key: "getQueueStatsBySid",
        value: (S = w(_regeneratorRuntime.mark(function e(t) {
          var n;
          return _regeneratorRuntime.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return j(this, f).call(this), e.next = 3, j(this, i).call(this, t);

                case 3:
                  return n = e.sent, e.abrupt("return", n);

                case 5:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function (e) {
          return S.apply(this, arguments);
        })
      }, {
        key: "getWorkspaceStats",
        value: (O = w(_regeneratorRuntime.mark(function t() {
          var n, o, i, a;
          return _regeneratorRuntime.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return t.prev = 0, t.next = 3, j(this, u).getWorkspaceStats();

                case 3:
                  return n = t.sent, o = {
                    mapKeysToCamelCase: !0,
                    dateFields: ["workspaceModified, longestTaskWaitingFrom", "timestamp"]
                  }, t.abrupt("return", n.getSubscribable(o));

                case 8:
                  return t.prev = 8, t.t0 = t.catch(0), (null === (i = t.t0.wrappedError) || void 0 === i ? void 0 : i.code) === p.e.SyncNameNotFoundError && j(this, l).call(this, t.t0, "Workspace statistics"), a = {
                    module: Object(y.b)(e),
                    severity: p.b.Error,
                    source: Object(y.a)(r)
                  }, t.abrupt("return", j(this, s).call(this, t.t0, a));

                case 13:
                case "end":
                  return t.stop();
              }
            }
          }, t, this, [[0, 8]]);
        })), function () {
          return O.apply(this, arguments);
        })
      }]) && g(n.prototype, o), m && g(n, m), t;
    }())) || o;
  }).call(this, "/", "/index.js");
}, function (e, t, n) {
  "use strict";

  var r = n(64);
  n.d(t, "a", function () {
    return r.a;
  });
}, function (e, t, n) {
  "use strict";

  (function (e) {
    n.d(t, "a", function () {
      return d;
    });
    n(5), n(3), n(6), n(11), n(7), n(8);
    var r,
        o,
        i = n(0),
        a = n(1),
        u = n(12),
        c = n(2);

    function s(e, t, n, r, o, i, a) {
      try {
        var u = e[i](a),
            c = u.value;
      } catch (e) {
        return void n(e);
      }

      u.done ? t(c) : Promise.resolve(c).then(r, o);
    }

    function l(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function f(e, t) {
      var n = t.get(e);
      if (!n) throw new TypeError("attempted to get private field on non-instance");
      return n.get ? n.get.call(e) : n.value;
    }

    var d = Object(i.injectable)()((o = new WeakMap(), r = function () {
      function t(e, n) {
        var r, i, a;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), a = "http://flex-sdk.twilio.com/v1", (i = "basePath") in (r = this) ? Object.defineProperty(r, i, {
          value: a,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : r[i] = a, o.set(this, {
          writable: !0,
          value: void 0
        }), this.twilsockAdapter = e, function (e, t, n) {
          var r = t.get(e);
          if (!r) throw new TypeError("attempted to set private field on non-instance");
          if (r.set) r.set.call(e, n);else {
            if (!r.writable) throw new TypeError("attempted to set read only private field");
            r.value = n;
          }
        }(this, o, n);
      }

      var n, r, d, p, v;
      return t = Object(i.inject)(a.j)(t, void 0, 1) || t, t = Object(i.inject)(u.f)(t, void 0, 0) || t, n = t, (r = [{
        key: "postTelemetryEvents",
        value: (p = _regeneratorRuntime.mark(function t(n) {
          var r, i;
          return _regeneratorRuntime.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return null == n && (r = {
                    module: "backend",
                    severity: a.b.Error,
                    source: Object(c.a)(e)
                  }, f(this, o).call(this, a.a.InvalidParams, r, "Required parameter events was null or undefined when calling postTelemetryEvents.")), t.next = 3, this.twilsockAdapter.post("".concat(this.basePath, "/Telemetry/Events"), n);

                case 3:
                  return i = t.sent, t.abrupt("return", i);

                case 5:
                case "end":
                  return t.stop();
              }
            }
          }, t, this);
        }), v = function v() {
          var e = this,
              t = arguments;
          return new Promise(function (n, r) {
            var o = p.apply(e, t);

            function i(e) {
              s(o, n, r, i, a, "next", e);
            }

            function a(e) {
              s(o, n, r, i, a, "throw", e);
            }

            i(void 0);
          });
        }, function (e) {
          return v.apply(this, arguments);
        })
      }]) && l(n.prototype, r), d && l(n, d), t;
    }())) || r;
  }).call(this, "/index.js");
}, function (e, t, n) {
  "use strict";

  (function (e) {
    n.d(t, "a", function () {
      return p;
    });
    n(22), n(5), n(3), n(6), n(11), n(7), n(8);
    var r,
        o,
        i = n(0),
        a = n(1),
        u = n(12),
        c = n(2);

    function s(e, t, n, r, o, i, a) {
      try {
        var u = e[i](a),
            c = u.value;
      } catch (e) {
        return void n(e);
      }

      u.done ? t(c) : Promise.resolve(c).then(r, o);
    }

    function l(e) {
      return function () {
        var t = this,
            n = arguments;
        return new Promise(function (r, o) {
          var i = e.apply(t, n);

          function a(e) {
            s(i, r, o, a, u, "next", e);
          }

          function u(e) {
            s(i, r, o, a, u, "throw", e);
          }

          a(void 0);
        });
      };
    }

    function f(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function d(e, t) {
      var n = t.get(e);
      if (!n) throw new TypeError("attempted to get private field on non-instance");
      return n.get ? n.get.call(e) : n.value;
    }

    var p = Object(i.injectable)()((o = new WeakMap(), r = function () {
      function t(e, n) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), o.set(this, {
          writable: !0,
          value: void 0
        }), this.syncAdapter = e, function (e, t, n) {
          var r = t.get(e);
          if (!r) throw new TypeError("attempted to set private field on non-instance");
          if (r.set) r.set.call(e, n);else {
            if (!r.writable) throw new TypeError("attempted to set read only private field");
            r.value = n;
          }
        }(this, o, n);
      }

      var n, r, s, p, v, b, h;
      return t = Object(i.inject)(a.j)(t, void 0, 1) || t, t = Object(i.inject)(u.d)(t, void 0, 0) || t, n = t, (r = [{
        key: "getCurrentTasksStats",
        value: (h = l(_regeneratorRuntime.mark(function t(n) {
          var r, i;
          return _regeneratorRuntime.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return null == n && (r = {
                    module: "backend",
                    severity: a.b.Error,
                    source: Object(c.a)(e)
                  }, d(this, o).call(this, a.a.InvalidParams, r, "Required parameter queueSid was null or undefined.")), t.next = 3, this.syncAdapter.getSyncObjectByPath("/flex_insights/Maps/".concat(encodeURIComponent(String(n)), ".realtime_statistics.v1/Items/tasks_now"));

                case 3:
                  return i = t.sent, t.abrupt("return", i);

                case 5:
                case "end":
                  return t.stop();
              }
            }
          }, t, this);
        })), function (e) {
          return h.apply(this, arguments);
        })
      }, {
        key: "getHistoricalStats",
        value: (b = l(_regeneratorRuntime.mark(function t(n, r) {
          var i, u, s;
          return _regeneratorRuntime.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return null == n && (i = {
                    module: "backend",
                    severity: a.b.Error,
                    source: Object(c.a)(e)
                  }, d(this, o).call(this, a.a.InvalidParams, i, "Required parameter queueSid was null or undefined.")), null == r && (u = {
                    module: "backend",
                    severity: a.b.Error,
                    source: Object(c.a)(e)
                  }, d(this, o).call(this, a.a.InvalidParams, u, "Required parameter timeSpanBucketKey was null or undefined.")), t.next = 4, this.syncAdapter.getSyncObjectByPath("/flex_insights/Maps/".concat(encodeURIComponent(String(n)), ".realtime_statistics.v1/Items/").concat(encodeURIComponent(String(r))));

                case 4:
                  return s = t.sent, t.abrupt("return", s);

                case 6:
                case "end":
                  return t.stop();
              }
            }
          }, t, this);
        })), function (e, t) {
          return b.apply(this, arguments);
        })
      }, {
        key: "getMetadata",
        value: (v = l(_regeneratorRuntime.mark(function t(n) {
          var r, i;
          return _regeneratorRuntime.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return null == n && (r = {
                    module: "backend",
                    severity: a.b.Error,
                    source: Object(c.a)(e)
                  }, d(this, o).call(this, a.a.InvalidParams, r, "Required parameter queueSid was null or undefined.")), t.next = 3, this.syncAdapter.getSyncObjectByPath("/flex_insights/Maps/".concat(encodeURIComponent(String(n)), ".realtime_statistics.v1/Items/metadata"));

                case 3:
                  return i = t.sent, t.abrupt("return", i);

                case 5:
                case "end":
                  return t.stop();
              }
            }
          }, t, this);
        })), function (e) {
          return v.apply(this, arguments);
        })
      }, {
        key: "getWorkerStats",
        value: (p = l(_regeneratorRuntime.mark(function t(n) {
          var r, i;
          return _regeneratorRuntime.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return null == n && (r = {
                    module: "backend",
                    severity: a.b.Error,
                    source: Object(c.a)(e)
                  }, d(this, o).call(this, a.a.InvalidParams, r, "Required parameter queueSid was null or undefined.")), t.next = 3, this.syncAdapter.getSyncObjectByPath("/flex_insights/Maps/".concat(encodeURIComponent(String(n)), ".realtime_statistics.v1/Items/worker_activities_statistics"));

                case 3:
                  return i = t.sent, t.abrupt("return", i);

                case 5:
                case "end":
                  return t.stop();
              }
            }
          }, t, this);
        })), function (e) {
          return p.apply(this, arguments);
        })
      }]) && f(n.prototype, r), s && f(n, s), t;
    }())) || r;
  }).call(this, "/index.js");
}, function (e, t, n) {
  "use strict";

  (function (e) {
    n.d(t, "a", function () {
      return v;
    });
    n(22), n(5), n(3), n(6), n(11), n(7), n(8);
    var r,
        o,
        i = n(0),
        a = n(1),
        u = n(12),
        c = n(68),
        s = n(2);

    function l(e, t, n, r, o, i, a) {
      try {
        var u = e[i](a),
            c = u.value;
      } catch (e) {
        return void n(e);
      }

      u.done ? t(c) : Promise.resolve(c).then(r, o);
    }

    function f(e) {
      return function () {
        var t = this,
            n = arguments;
        return new Promise(function (r, o) {
          var i = e.apply(t, n);

          function a(e) {
            l(i, r, o, a, u, "next", e);
          }

          function u(e) {
            l(i, r, o, a, u, "throw", e);
          }

          a(void 0);
        });
      };
    }

    function d(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function p(e, t) {
      var n = t.get(e);
      if (!n) throw new TypeError("attempted to get private field on non-instance");
      return n.get ? n.get.call(e) : n.value;
    }

    var v = Object(i.injectable)()((o = new WeakMap(), r = function () {
      function t(e, n) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), o.set(this, {
          writable: !0,
          value: void 0
        }), this.httpAdapter = e, function (e, t, n) {
          var r = t.get(e);
          if (!r) throw new TypeError("attempted to set private field on non-instance");
          if (r.set) r.set.call(e, n);else {
            if (!r.writable) throw new TypeError("attempted to set read only private field");
            r.value = n;
          }
        }(this, o, n);
      }

      var n, r, l, v, b, h;
      return t = Object(i.inject)(a.j)(t, void 0, 1) || t, t = Object(i.inject)(u.b)(t, void 0, 0) || t, n = t, (r = [{
        key: "fetchConfiguration",
        value: (h = f(_regeneratorRuntime.mark(function e() {
          var t, n;
          return _regeneratorRuntime.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return e.next = 2, this.httpAdapter.get("https://flex-api[environment].twilio.com/v1/Configuration", "jwe");

                case 2:
                  return t = e.sent, n = Object(c.a)(t), e.abrupt("return", n);

                case 5:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function () {
          return h.apply(this, arguments);
        })
      }, {
        key: "fetchPublicConfiguration",
        value: (b = f(_regeneratorRuntime.mark(function t(n, r) {
          var i, u, l, f;
          return _regeneratorRuntime.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return null == n && (i = {
                    module: "backend",
                    severity: a.b.Error,
                    source: Object(s.a)(e)
                  }, p(this, o).call(this, a.a.InvalidParams, i, "Required parameter queryParamName was null or undefined.")), null == r && (u = {
                    module: "backend",
                    severity: a.b.Error,
                    source: Object(s.a)(e)
                  }, p(this, o).call(this, a.a.InvalidParams, u, "Required parameter queryParamValue was null or undefined.")), t.next = 4, this.httpAdapter.get("https://flex-api[environment].twilio.com/v1/Configuration/Public?".concat(encodeURIComponent(String(n)), "=").concat(encodeURIComponent(String(r))), void 0);

                case 4:
                  return l = t.sent, f = Object(c.a)(l), t.abrupt("return", f);

                case 7:
                case "end":
                  return t.stop();
              }
            }
          }, t, this);
        })), function (e, t) {
          return b.apply(this, arguments);
        })
      }, {
        key: "updateConfiguration",
        value: (v = f(_regeneratorRuntime.mark(function t(n) {
          var r, i, u;
          return _regeneratorRuntime.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return null == n && (r = {
                    module: "backend",
                    severity: a.b.Error,
                    source: Object(s.a)(e)
                  }, p(this, o).call(this, a.a.InvalidParams, r, "Required parameter accountConfigData was null or undefined.")), t.next = 3, this.httpAdapter.post("https://flex-api[environment].twilio.com/v1/Configuration", "jwe", n);

                case 3:
                  return i = t.sent, u = Object(c.a)(i), t.abrupt("return", u);

                case 6:
                case "end":
                  return t.stop();
              }
            }
          }, t, this);
        })), function (e) {
          return v.apply(this, arguments);
        })
      }]) && d(n.prototype, r), l && d(n, l), t;
    }())) || r;
  }).call(this, "/index.js");
}, function (e, t) {
  e.exports = require("reflect-metadata");
}, function (e, t) {
  e.exports = require("core-js/modules/es.object.assign.js");
}, function (e, t, n) {
  "use strict";

  n.r(t), n.d(t, "LoggerName", function () {
    return c.b;
  }), n.d(t, "ClientEvent", function () {
    return a.a;
  }), n.d(t, "TimeSpan", function () {
    return l.b;
  }), n.d(t, "QueueStatsItemKey", function () {
    return l.a;
  }), n.d(t, "auth", function () {
    return d;
  }), n.d(t, "getLogger", function () {
    return p;
  }), n.d(t, "getTwilioIdpUrl", function () {
    return v;
  }), n.d(t, "getPublicConfig", function () {
    return b;
  }), n.d(t, "createClient", function () {
    return h;
  }), n.d(t, "version", function () {
    return y;
  }), n.d(t, "FlexSdkError", function () {
    return f.c;
  }), n.d(t, "ErrorCode", function () {
    return f.a;
  }), n.d(t, "ErrorSeverity", function () {
    return f.b;
  });
  var r = n(65),
      o = n(46),
      i = n(9),
      a = n(14),
      u = n(33),
      c = n(4);

  function s(e) {
    return function (t) {
      return function () {
        var n = e(),
            r = n.get(t);
        return r.apply(void 0, arguments);
      };
    };
  }

  var l = n(48),
      f = n(1),
      d = s(o.a)(u.a),
      p = s(o.b)(c.d),
      v = s(o.a)(u.c),
      b = s(o.a)(i.e),
      h = s(o.a)(a.c),
      y = r.a;
}, function (e, t) {
  e.exports = require("core-js/modules/es.array.find.js");
}, function (e, t) {
  e.exports = require("core-js/modules/es.number.constructor.js");
}, function (e, t) {
  e.exports = require("core-js/modules/es.number.is-nan.js");
}, function (e, t) {
  e.exports = require("core-js/modules/es.string.ends-with.js");
}, function (e, t) {
  e.exports = require("core-js/modules/es.array.filter.js");
}, function (e, t) {
  e.exports = require("core-js/modules/es.object.entries.js");
}, function (e, t) {
  e.exports = require("core-js/modules/es.regexp.constructor.js");
}, function (e, t) {
  e.exports = require("core-js/modules/es.string.split.js");
}, function (e, t) {
  e.exports = require("core-js/modules/es.string.starts-with.js");
}]);